<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
        v-if="task_data && classifiers_loaded"
        ref="taskViewCard"
        :class="[
            'dialog-card task-card pa-0 elevation-0',
            dnd_over ? 'task-dnd-over' : 'task-dnd-out',
            auto_save ? 'task-auto-save' : ''
        ]"
        :style="isFullPage && footer_action ? 'margin-bottom: -100px' : ''"
        @dragover.stop.prevent="upload_dragover"
        @drop.stop.prevent="upload_drop"
        @dragleave.stop.prevent="upload_dragleave"
    >
        <v-card-text class="dialog-content pa-0">
            <div>
                <TaskMobileToolbar
                    :is-full-page="isFullPage"
                    :task-data="task_data"
                    :menu-items="menu_items"
                    @toggle_field="toggle_field"
                    @action_click="action_click"
                    @close_click="close_click"
                />

                <div
                    ref="formContentRef"
                    class="form-content"
                    :style="{ minHeight: content_height, paddingTop: isFullPage ? '56px' : '' }"
                >
                    <div class="hide-file-input">
                        <input
                            id="userfile735"
                            ref="userfile735"
                            type="file"
                            multiple
                            name="userfile735"
                            @change="upload_change"
                        />
                    </div>
                    <!--slot name="test"></slot-->
                    <div :class="header_class">
                        <div
                            class="d-flex pl-sm-8 pr-sm-6 px-0 ma-0"
                            :class="task_data.recurrence_rule ? 'mb-4 pt-1 pb-1' : 'pb-4 pt-5'"
                            style="justify-content: space-between;"
                        >
                            <TaskTitleComponent
                                ref="titleField"
                                v-model="task_data.title"
                                :is-full-page="isFullPage"
                                :show-autocomplete="new_task && !isTemplate && !task_data.project_id"
                                :error-message="form_data.title_error"
                                :show-overdue="task_data.calc_status === 'overdue' && task_data.recurrence_rule == null && !isWorkflowTemplate"
                                :overdue-seconds="task_data.overdue_seconds"
                                :task-errors="taskErrors"
                                :autofocus-field="autoFocusField"
                                :is-recurring="!!task_data.recurrence_rule"
                                :is-task-button="isTaskButton"
                                :task-data="task_data"
                                :auto-save="auto_save"
                                :recurrence-rule-field="recurrenceRuleField"
                                :menu-items="menu_items"
                                :estimations_menu="estimations_menu"
                                :clients="clients"
                                :companyId="companyId ? companyId : task_data.account_id"
                                @input="form_data.title_error = null"
                                @autocomplete-select="autocomplete_select"
                                @save-field="set_and_save_field"
                                @focus-field="focus_field"
                                @close_click="close_click"
                                @focus_field="focus_field"
                                @toggle_field="toggle_field"
                                @action_click="action_click"
                            />
                        </div>
                    </div>
                    <div class="ma-0 d-flex" :class="[{ 'px-3': isFullPage }]">
                        <div
                            :class="['pl-md-11 pt-0', { 'px-3': isFullPage }]"
                            :style="!isFullPage ? 'width: 71%;' : ''"
                        >
                            <div class="pb-4 fields-flow-container">
                                <div v-if="!isGeneralTemplate && !isJobTemplate" class="mr-3 fields-flow-item">
                                    <ClientsField
                                        ref="clientField"
                                        :new-client-enabled="!isTaskButton"
                                        :label="$t('Client')"
                                        :value="task_data.client_id"
                                        :items="clients"
                                        :disabled="!client_enabled"
                                        :error-messages="form_data.client_id_error"
                                        :autofocus-field="autoFocusField"
                                        @change="client_changed"
                                        @tab_next="focus_next('client_id')"
                                        @close_click="close_click"
                                    ></ClientsField>
                                </div>
                                <div v-if="projectVisible && projectEnabled" class="mr-3 fields-flow-item">
                                    <ProjectField
                                        ref="projectField"
                                        :value="task_data.project_id"
                                        :value-disp="task_data.project"
                                        :account-id="task_data.account_id"
                                        :client-id="task_data.client_id"
                                        :show-status="!isTemporaryClientTask"
                                        :error-messages="form_data.project_id_error"
                                        :disabled="!project_enabled"
                                        :task="task_data"
                                        @change="saveProjectId"
                                        @close_click="close_click"
                                    />
                                </div>
                                <div
                                    v-if="isWorkflowTemplate || (projectEnabled && task_data.project_id)"
                                    class="mr-3 fields-flow-item"
                                >
                                    <ProjectStatusField
                                        :value="task_data.project_status_from"
                                        :account-id="task_data.account_id"
                                        :error-messages="form_data.project_status_from_error"
                                        @change="set_and_save_field('project_status_from', $event)"
                                    ></ProjectStatusField>
                                </div>
                                <TaskAssignees
                                    v-if="!isJobTemplate && isFullPage"
                                    ref="assigneesField"
                                    :users="users"
                                    :assignees="task_data.assignees"
                                    :error-messages="form_data.assignees_error"
                                    :is-fullscreen="isFullPage"
                                    @change="set_and_save_field('assignees', $event)"
                                    @keep_only="keep_only_me"
                                    @focus_next="focus_next('assignees')"
                                />
                                <div v-if="!isGeneralTemplate && !isTaskButton && isFullPage" class="mb-4 fields-flow-item" style="flex-basis: 100%;">
                                    <FollowersField
                                        :label="$t('Followers')"
                                        :value="task_data.followers ? task_data.followers : []"
                                        :items="users"
                                        :error-messages="form_data.followers_error"
                                        @change="set_and_save_field('followers', $event)"
                                    ></FollowersField>
                                </div>
                                <div
                                    v-if="!isTaskButton"
                                    class="mr-3 fields-flow-item"
                                    style="flex-basis: auto;"
                                >
                                    <div v-if="isWorkflowTemplate || hasWorkflowDateRule">
                                        <WorkflowDateField
                                            v-if="task_data.project || isWorkflowTemplate"
                                            :label="$t('Start / Due date')"
                                            :task="task_data"
                                            :picker-type="isWorkflowTemplate ? 'workflow' : 'project'"
                                            :error-messages="workflow_date_rule_error"
                                            @change="save_custom_field('workflow_date_rule', $event)"
                                        ></WorkflowDateField>
                                    </div>
                                    <RecurrenceField
                                        v-else
                                        ref="recurrenceRuleField"
                                        :label="$t('Start / Due date')"
                                        :task="task_data"
                                        :error-messages="recurrence_rule_error"
                                        :picker-type="isWorkflowTemplate ? 'workflow' : 'standard'"
                                        @change="save_recurrence_field($event)"
                                        @tab_next="focus_next('recurrence_rule')"
                                    ></RecurrenceField>
                                </div>
                                <div v-if="dependsOnVisible" class="mr-3 fields-flow-item">
                                    <RelatedTaskField
                                        ref="relatedTaskField"
                                        :label="$t('Depends on')"
                                        :value="task_data.depends_on === undefined ? [] : task_data.depends_on"
                                        :task-id="task_data.id"
                                        :items="curAvailableRelatedTasks"
                                        :error-messages="form_data.depends_on_error"
                                        @change="set_and_save_field('depends_on', $event)"
                                        @filterTasks="filterDependantTasks"
                                    />
                                </div>
                                <div
                                    v-if="show_topic && isFullPage"
                                    class="mr-3 fields-flow-item"
                                >
                                    <TopicsField
                                        ref="topicField"
                                        v-slot="{ on, is_menu_open }"
                                        :label="$t('Topic')"
                                        :value="task_data.topic_id"
                                        :account-id="task_data.account_id"
                                        :items="topics"
                                        :error-messages="form_data.topic_id_error"
                                        @select_account="focus_next('client_id', true)"
                                        @change="set_and_save_field('topic_id', $event)"
                                    >
                                        <div
                                            tabindex="0"
                                            class="disp cursor-pointer"
                                            v-on="on"
                                        >
                                            <div
                                                v-if="currentTopic"
                                                class="d-flex"
                                            >
                                                <div class="val mx-2">{{ currentTopic.name }}</div>
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="val ml-2"
                                                    style="color: var(--v-n4-base);"
                                                >
                                                    {{ $t("Select topic") }}
                                                </div>
                                                <div :class="['arrow', is_menu_open ? 'arrow--open' : '']">
                                                    <icon
                                                        size="20"
                                                        icon="ChevronDown"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </TopicsField>
                                </div>
                                <TaskBillBy
                                    v-if="show_bill_by"
                                    :bill-by="task_data.bill_by"
                                    :bill-at="task_data.bill_at"
                                    :error-messages="form_data.bill_by_error"
                                    @update-bill-by="onSetBillBy"
                                    @update-bill-at="onSetBillAt"
                                />
                                <TaskEstimation
                                    ref="estimationField"
                                    :form-data="form_data"
                                    :task-data="task_data"
                                    :estimations-menu="estimations_menu"
                                    @updateMenuState="estimations_menu = $event"
                                    @time_field_changed="time_field_changed"
                                    @estimation_select="estimation_select"
                                />
                                <template>
                                    <CustomField
                                        v-for="field in form_data_fields"
                                        :key="field.name"
                                        :account-id="task_data.account_id"
                                        :field="field.field"
                                        :error-messages="task_data.fields ? task_data.fields[field.name + '_error'] : null"
                                        :value="field.value"
                                        class="mr-3 fields-flow-item"
                                        input-css-class="task-form-elem font-weight-medium"
                                        style="flex-basis: 135px;"
                                        @change="save_custom_field(field.name, $event)"
                                    ></CustomField>
                                </template>
                            </div>
                            <div class="pb-4">
                                <ChecklistField
                                    :task-id="
                                        task_data.id ? task_data.id : task_data.virtual_id ? task_data.virtual_id : 0
                                    "
                                    :value="task_data.checklist"
                                    :is-temporary-client-task="isTemporaryClientTask"
                                    :auto-save="!!auto_save"
                                    :is-full-page="isFullPage"
                                    :account="current_account"
                                    :can-track-time="show_timer"
                                    @convert-to-task="convertChecklistItemToNewTask"
                                    @start-timer="startChecklistTimer"
                                    @change="update_checklist_field"
                                ></ChecklistField>
                            </div>
                            <TaskNotes
                                ref="taskNotes"
                                v-model="task_data.description"
                                :is-full-page="isFullPage"
                                :description-edit="form_data.description_edit"
                                :auto_save="auto_save"
                                @descriptionEdit="form_data.description_edit = $event"
                                @save_field="set_and_save_field('description', $event)"
                                @focus_field="focus_field"
                            />
                            <div
                                v-if="isTaskButton"
                                class="pb-4"
                            >
                                <MagicButtonSettings
                                    :task-button-settings.sync="task_data.task_button"
                                    :task-button-description-error="form_data.task_button_description_error"
                                />
                            </div>
                            <div
                                v-if="filteredFiles.length"
                                class="pb-4"
                            >
                                <div class="d-flex align-center justify-space-between mb-1">
                                    <div class="caption n3--text">
                                        {{ filteredFiles.length === 1 ? $t('1 document') : $t('{0} documents').format(filteredFiles.length) }}
                                    </div>
                                    <div>
                                        <mini-secondary-button
                                            icon="Download"
                                            @click="onDownloadAllFiles"
                                        >
                                            {{ filteredFiles.length === 1 ? $t('Download') : $t('Download all') }}
                                        </mini-secondary-button>
                                        <mini-secondary-button
                                            v-if="digitizationEmail"
                                            icon="FileInput"
                                            @click="isDigitizationModalOpen = true"
                                        >
                                            {{ $t('Digitise') }}
                                        </mini-secondary-button>
                                    </div>
                                </div>
                                <AttachmentsList
                                    :files="filteredFiles"
                                    @download="download($event)"
                                    @delete_file="onDeleteFile"
                                ></AttachmentsList>
                            </div>
                            <div class="pb-4">
                                <TaskAutomationList
                                    v-if="visibleAutomations && !isTaskButton"
                                    :automations="visibleAutomations"
                                    :can-edit="editingAutomationIndex === null && footer_action !== TASK_FOOTER_ACTIONS.ADD_EMAIL && !isFullPage"
                                    :account-id="task_data.account_id"
                                    :emailing-enabled="emailingEnabled"
                                    :can-send-now="!isEmailingOnlyAutomations"
                                    :is-full-page="isFullPage"
                                    :client-id="isTemplate && !isTemporaryClientTask ? null : task_data.client_id"
                                    @editAutomation="editAutomation"
                                    @updateAutomations="updateAutomations"
                                />
                            </div>
                            <div class="pb-4">
                                <TaskInfoList
                                    v-if="task_data.logs !== undefined && task_data.logs.length > 0 && !isTaskButton"
                                    :task-id="task_data.id ? task_data.id : task_data.virtual_id ? task_data.virtual_id : 0"
                                    :account-id="task_data.account_id"
                                    :logs="task_data.logs"
                                    :tasks-list="tasks_list"
                                    :is-full-page="isFullPage"
                                    @reply="$event === 'message' && clientPortalEnabled && task_data.is_cp ? add_message_or_comment() : add_comment()"
                                ></TaskInfoList>
                            </div>
                        </div>
                        <div
                            v-if="!isFullPage"
                            class="py-0 px-6"
                            style="width: 29%;"
                        >
                            <TaskAssignees
                                v-if="!isJobTemplate && !isTaskButton"
                                ref="assigneesField"
                                :users="users"
                                :assignees="task_data.assignees"
                                :error-messages="form_data.assignees_error"
                                :is-fullscreen="isFullPage"
                                @change="set_and_save_field('assignees', $event)"
                                @keep_only="keep_only_me"
                                @focus_next="focus_next('assignees')"
                            />
                            <FollowersField
                                v-if="!isGeneralTemplate && !isTaskButton"
                                :label="$t('Followers')"
                                :value="task_data.followers ? task_data.followers : []"
                                :items="users"
                                :error-messages="form_data.followers_error"
                                @change="set_and_save_field('followers', $event)"
                            ></FollowersField>
                            <TopicsField
                                ref="topicField"
                                v-slot="{ on }"
                                :label="$t('Topic')"
                                :value="task_data.topic_id"
                                :account-id="task_data.account_id"
                                :items="topics"
                                :error-messages="form_data.topic_id_error"
                                @select_account="focus_next('client_id', true)"
                                @change="set_and_save_field('topic_id', $event)"
                            >
                                <v-tooltip
                                    bottom
                                    open-delay="250"
                                    :disabled="!currentTopic"
                                >
                                    <template v-slot:activator="{ on: tooltipOn }">
                                        <div v-on="tooltipOn">
                                            <v-btn
                                                depressed
                                                block
                                                class="grey-button mb-2"
                                                v-on="on"
                                            >
                                                <div class="flex-shrink-0">
                                                    <icon icon="Tag" size="20"/>
                                                </div>
                                                <div
                                                    v-if="task_data.topic_id"
                                                    class="font-weight-medium main--text px-1 subtitle-2 d-flex align-center overflow-hidden"
                                                >
                                                    <div class="text-truncate">
                                                        {{ currentTopic != null ? currentTopic.name : "?" }}
                                                    </div>
                                                    <div
                                                        v-if="!currentTopic.billable"
                                                        class="flex-shrink-0"
                                                    >
                                                        <icon
                                                            icon="non_billable"
                                                            size="20"
                                                            color="error"
                                                        />
                                                    </div>
                                                </div>
                                                <span v-else>{{ $t("Topic") }}</span>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span v-if="currentTopic" class="ml-1">{{ currentTopic.name }}</span>
                                </v-tooltip>
                            </TopicsField>
                            <div
                                v-if="clientPortalVisible"
                                class="mb-4"
                            >
                                <!--div class="global-label">{{ $t("Client portal") }}</div-->
                                <v-btn
                                    v-if="!task_data.is_cp"
                                    depressed
                                    block
                                    class="grey-button mb-2"
                                    @click="set_and_save_field('is_cp', 1)"
                                >
                                    <v-icon>mdi-account-multiple-outline</v-icon>
                                    {{ $t('Client portal') }}
                                </v-btn>
                                <div
                                    v-else
                                    class="n1 pa-2 rounded-lg cp-assign-menu"
                                >
                                    <div v-if="isJobTemplate || isWorkflowTemplate">
                                        <UserButton
                                            :person="{
                                                name: $t('Primary contact'),
                                                type: 'group',
                                                initials: $t('Contact')[0]
                                            }"
                                        />
                                    </div>
                                    <TaskAssignees
                                        v-else
                                        ref="cpAssigneesField"
                                        :users="cp_users"
                                        :label="$t('Client portal')"
                                        :assignees="task_data.cp_assignees"
                                        :error-messages="form_data.cp_assignees_error"
                                        :is-fullscreen="isFullPage"
                                        @change="set_and_save_field('cp_assignees', $event)"
                                    />
                                    <div class="mt-2">
                                        <div class="task-field">
                                            <switch-button
                                                v-model="task_data.cp_is_task"
                                                color="tretiary"
                                                class="task-field"
                                                :label="$t('Assign as task')"
                                                :error-messages="form_data.cp_is_task_error"
                                                @change="set_and_save_field('cp_is_task', $event)"
                                            >
                                                <template #append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon
                                                                class="mt-1"
                                                                small
                                                                v-on="on"
                                                            >
                                                                mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>{{ $t('When selected, the task is sent as a task to the client') }}</span>
                                                    </v-tooltip>
                                                </template>
                                            </switch-button>
                                        </div>
                                        <div v-if="task_data.cp_is_task">
                                            <SecondaryCheckbox
                                                :value="task_data.cp_auto_finish"
                                                class="mt-1 task-field"
                                                :color="task_data.cp_assignees.length < 1 ? '': 'n4'"
                                                :disabled="task_data.cp_assignees.length < 1 && !(isWorkflowTemplate || isJobTemplate)"
                                                :custom-icons="false"
                                                :label="$t('Auto finish')"
                                                :error-messages="form_data.cp_auto_finish_error"
                                                :title="$t('When selected, the task is marked done after client finishes it')"
                                                @change="set_and_save_field('cp_auto_finish')"
                                            />
                                        </div>
                                        <div
                                            v-if="task_data.cp_is_task && cpDueDateOffsetOptionsFiltered.length && ((task_data.has_due_date && task_data.due_date) || isWorkflowTemplate || isJobTemplate || task_data.recurrence_rule)"
                                            class="mt-2"
                                        >
                                            <icon
                                                color="n3"
                                                icon="CalendarDays"
                                            />
                                            <action-menu
                                                :items="cpDueDateOffsetOptionsFiltered"
                                                :absolute="false"
                                                @action="set_and_save_field('cp_due_date_offset', cpDueDateOffsetOptionsFiltered[$event].value)"
                                            >
                                                <template #activator="{ on: menuOn, isOpen }">
                                                    <v-tooltip
                                                        bottom
                                                        :disabled="!currentlySelectedDueDateOffsetOptionText"
                                                    >
                                                        <template #activator="{ on: tooltipOn }">
                                                            <v-btn
                                                                style="height: unset"
                                                                class="px-2 py-1"
                                                                text
                                                                v-on="{ ...menuOn, ...tooltipOn }"
                                                            >
                                                                <div class="caption n4--text text-none">
                                                                    {{ cpDueDateText }}
                                                                </div>
                                                                <div class="ml-1">
                                                                    <icon
                                                                        color="n4"
                                                                        size="16"
                                                                        :icon="isOpen ? 'ChevronUp' : 'ChevronDown'"
                                                                    />
                                                                </div>
                                                            </v-btn>
                                                        </template>
                                                        {{ currentlySelectedDueDateOffsetOptionText }}
                                                    </v-tooltip>
                                                </template>
                                            </action-menu>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="show_footer"
                    :class="isFullPage ? 'd-flex align-center px-3 mobile-footer' : 'px-3 desktop-footer'"
                >
                    <v-row
                        v-if="!isFullPage"
                        class="px-sm-8 px-0 py-4 ma-0 default-footer"
                    >
                        <v-col class="col-12 d-flex align-center justify-space-between pa-0">
                            <div class="footer-actions d-flex pa-0 align-center">
                                <v-tooltip v-if="comment_enabled" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :on="on"
                                                icon="MessageSquare"
                                                @click="clientPortalEnabled && task_data.is_cp ? add_message_or_comment() : add_comment()"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add comment / message") }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="emailingEnabled" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :on="on"
                                                icon="Mail"
                                                @click="showFooterEmailing"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add email") }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="!isTaskButton" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :on="on"
                                                icon="Paperclip"
                                                @click="userfile735.click()"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add attachment") }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="!isTaskButton" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :on="on"
                                                icon="Clock4"
                                                @click="action_click('enable_estimation')"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add estimation") }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="!isTaskButton" :disabled="custom_fields.length === 0" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :disabled="custom_fields.length === 0"
                                                :on="on"
                                                icon="FormInput"
                                                @click="open_custom_field_dialog"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add task field") }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="!isTaskButton" bottom open-delay="250">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="mr-1">
                                            <icon-button
                                                :on="on"
                                                icon="Replace"
                                                @click="action_click('enable_depends_on')"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("Add dependency") }}</span>
                                </v-tooltip>
                            </div>
                            <div class="d-flex align-center pa-0 text-right">
                                <TaskTimerControl
                                    v-if="show_timer"
                                    :is-mobile="false"
                                    :timer-time="timer_time"
                                    :is-task-running="isTaskRunning"
                                    :task-status="task_data.status"
                                    :start-loading="startLoading"
                                    :complete-loading="completeLoading"
                                    @manageTimeEntries="manage_time_entries"
                                    @toggleStarted="toggleStarted"
                                    @toggleCompleted="toggleCompleted"
                                ></TaskTimerControl>
                                <!--style="width: 68px;"-->
                                <v-tooltip :disabled="!save_button_tooltip_text" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            v-if="!auto_save && !isTaskButton"
                                            ref="saveButton1"
                                            color="primary"
                                            class="inverted--text ml-3"
                                            test-id="task-save-button"
                                            :loading="saveLoading"
                                            @click="handleSaveClick"
                                        >
                                            <span>{{ save_button_text }}</span>
                                        </v-btn>
                                    </template>
                                    {{ save_button_tooltip_text }}
                                </v-tooltip>
                                <v-btn
                                    v-if="isTaskButton"
                                    ref="saveButtonIsTaskButton"
                                    color="primary"
                                    class="inverted--text text-right ml-3"
                                    test-id="task-save-button"
                                    :loading="saveLoading"
                                    @click="postTaskButton"
                                >
                                    <span>{{ $t('Save') }}</span>
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                    <div v-else>
                        <template v-if="comment_enabled">
                            <PersonAvatar
                                :person="current_account"
                                :size="24"
                            ></PersonAvatar>
                            <v-btn
                                depressed
                                text
                                class="grey-button no-bg px-2"
                                @click="add_comment"
                            >
                                {{ $t("Comment") }}
                            </v-btn>
                        </template>
                        <v-spacer></v-spacer>
                        <TaskTimerControl
                            v-if="show_timer"
                            :is-mobile="true"
                            :timer-time="timer_time"
                            :is-task-running="isTaskRunning"
                            :task-status="task_data.status"
                            :start-loading="startLoading"
                            :complete-loading="completeLoading"
                            @manageTimeEntries="manage_time_entries"
                            @toggleStarted="toggleStarted"
                            @toggleCompleted="toggleCompleted"
                        ></TaskTimerControl>
                        <v-tooltip :disabled="!save_button_tooltip_text" bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    v-if="!auto_save"
                                    ref="saveButton2"
                                    color="primary"
                                    class="inverted--text text-right my-2 ml-3"
                                    test-id="task-save-button"
                                    v-on="on"
                                    :loading="saveLoading"
                                    @click="handleSaveClick"
                                >
                                    <span>{{ save_button_text }}</span>
                                </v-btn>
                            </template>
                            {{ save_button_tooltip_text }}
                        </v-tooltip>
                    </div>
                </div>
            </div>

            <TaskAddEmailControl
                v-if="footer_action === TASK_FOOTER_ACTIONS.ADD_EMAIL"
                :task-id="taskId"
                :account-id="task_data.account_id"
                :contact-tabs="emailContacts"
                :automations="visibleAutomations"
                :editing-automation-index="editingAutomationIndex"
                :is-template-task="isTemplate"
                :only-automations="isEmailingOnlyAutomations"
                :placeholder-types="emailingPlaceholderTypes"
                :client-id="isTemplate && !isTemporaryClientTask ? null : task_data.client_id"
                :clients="clients"
                @close="close_email"
                @saveAutomation="updateAutomations"
            />
            <TaskAddCommentControl
                v-else-if="footer_action === TASK_FOOTER_ACTIONS.ADD_COMMENT || footer_action === TASK_FOOTER_ACTIONS.ADD_MESSAGE"
                :task-data="task_data"
                :related-attachments="form_data.comment_attachments"
                :action-type="footer_action"
                :client-name="clientName"
                :users="cp_users"
                :messaging-available="clientPortalEnabled && task_data.is_cp"
                @close="close_comment"
                @upload_change="comment_upload_change"
                @message_sent="resetTaskIsSeenForCPAssignees"
                @update-action="footer_action = $event"
            ></TaskAddCommentControl>

            <TaskTimeEntriesControl
                v-if="show_timer && footer_action === TASK_FOOTER_ACTIONS.MANAGE_TIME_ENTRIES"
                :is-mobile="isFullPage"
                :task-id="task_data.id"
                :task-virtual-id="task_data.virtual_id"
                :is-task-running="isTaskRunning"
                :tracked-time="timer_time"
                :running-time="running_time"
                :task-rights="task_data.rights"
                :account-id="task_data.account_id"
                :existing-time-entry="form_data.time_entry"
                :topic="currentTopic"
                @set_time="setTimeEntry"
                @close="close_time_entries"
                @scrollDown="$emit('scrollDown', { task_content_height: formContentRef.clientHeight })"
            ></TaskTimeEntriesControl>

            <div class="dnd-layer" style="pointer-events: none">
                <div class="dnd-bg"></div>
                <div class="dnd-border"></div>
                <div class="dnd-text">
                    <div>
                        <icon
                            color="white"
                            :size="48"
                            icon="UploadCloud"
                        />
                    </div>
                    <div class="message">{{ $t("Drop files to upload") }}</div>
                </div>
            </div>
        </v-card-text>
        <TaskDigitizationModal
            v-if="isDigitizationModalOpen"
            :attachments="filteredFiles"
            :digitization-email="digitizationEmail"
            :client-id="task_data.client_id"
            @close="isDigitizationModalOpen = false"
        />
    </v-card>
</template>

<script>
/*

Different behaviours:

1. Add task (default) - load from store; no auto save;
   /tasks/0

2. Add task (from client view) - load from store; no auto save; client selected by default;
   /clients/:client_id/new_task
   /clients/:client_id/new_task_template - ? is mobile in use ?

3. View task - load from api; auto save;
   /tasks/:id
   /tasks/:virtual_id
   /clients/:client_id/tasks/:id
   /clients/:client_id/tasks/:virtual_id

4. Add task template (client plan/job plan) - object input; no save, object returned; monthly selected by default;
   - No mobile supported

5. View task template (client plan/job plan) - object input; no save, object returned;
   - No mobile supported

6. Create task template based on existing task - everything is pre-filled; no auto save;
   /tasks/:base_task_id/new_task_template
   /clients/:client_id/:base_task_id/new_task_template

7. Workflow

*/

import Vue from "vue";
import {ref, computed, watch, onMounted} from "@vue/composition-api";
import {Router} from "@/composables/Router";
import {$t} from "@/i18n";
import TaskModule from "../../store/modules/task";
import TimerModule from "../../store/modules/timer";
import AppModule from "../../store/modules/app";
import AccountModule from "../../store/modules/account";
import ClientModule from "../../store/modules/client";
import UserModule from "../../store/modules/user";
import DialogModule from "../../store/modules/dialog";
import ChecklistField from "../../components/ChecklistField.vue";
import ClientsField from "../../components/ClientsField.vue";
import ProjectField from "../../components/Task/ProjectField.vue";
import RelatedTaskField from "../../components/RelatedTaskField";
import TopicsField from "../../components/TopicsField.vue";
import TaskBillBy from "@/views/Task/TaskFields/TaskBillBy.vue";
import FollowersField from "../../components/FollowersField.vue";
import RecurrenceField from "../../components/Task/RecurrenceField/Index.vue";
import WorkflowDateField from "../../components/Task/WorkflowDateField";
import CustomField from "../../components/CustomField.vue";
import TaskAddEmailControl from "./TaskAddEmailControl/Index";
import TaskInfoList from "./TaskInfoList/TaskActivityList";
import TaskAutomationList from "./TaskInfoList/TaskAutomationList";
import PersonAvatar from "../../components/PersonAvatar.vue";
import SelectedUsersDesktop from "@/components/UsersField/SelectedUsersDesktop";
import AddUserButton from "@/components/UsersField/AddUserButton";
import AttachmentsList from "../../components/AttachmentsList.vue";
import TaskAddCommentControl from "../../views/Task/TaskAddCommentControl.vue";
import TaskTimeEntriesControl from "./TimeEntries/Index";
import FileUpload from "../../composables/FileUpload";
import TaskTimerControl from "../../views/Task/TaskTimerControl.vue";
import ClientAvatarListItem from "../../components/ClientAvatarListItem.vue";
import TaskTitleComponent from "@/views/Task/TaskFields/TaskTitle";
import TaskHeaderButtons from "@/views/Task/TaskFields/TaskHeaderButtons";
import TaskNotes from "@/views/Task/TaskFields/TaskNotes";
import TaskMobileToolbar from "@/views/Task/TaskFields/TaskMobileToolbar";
import TaskAssignees from "@/views/Task/TaskFields/TaskAssignees";
import MagicButtonSettings from "@/views/Task/MagicButtonSettings";
import TaskButtonModule from "@/store/modules/task_button";
import TaskEstimation from "@/views/Task/TaskFields/TaskEstimation";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import TaskSnoozeMenu from "./TaskSnoozeMenu";
import {
    parseSysDateTime,
    formatTimeDuration,
    parseTimeDuration,
    formatName,
    friendlyJoin,
    maxLength,
    formatSysDateTime,
    formatSysDate, formatDateShort
} from "@/plugins/formatting";
import SelectedUsersMobile from "@/components/UsersField/SelectedUsersMobile";
import SecondaryCheckbox from "@/components/Buttons/SecondaryCheckbox";
import ProjectStatusField from "../../components/Task/ProjectStatusField";
import {APP_STORE_APP_TYPES, EMAIL_AUTOMATION_PLACEHOLDER_TYPES} from "../../helpers/constants";
import {downloadFile, downloadFiles} from "@/helpers/helpers";
import EmailAutomationModule from "../../store/modules/email_automation";
import ApiEmailAutomationContacts from "../../api/email_automation/contacts";
import TaskValidationModule from "../../modules/task/validation"
import ApiTask from "../../api/task/task"
import ApiDigitization from '@/api/client/digitization'
import TimeEntryModule from "@/modules/timeEntry/timeEntry"
import FeedbackNotificationModule from "@/store/modules/feedback_notification"
import {
    FEATURE_ADD_TASK_CLIENT,
    isFeatureAllowed
} from "@/modules/subscription/allowed_features";
import {uku_send_event, UKU_ACTIVITIES} from "@/helpers/uku_activity";
import TaskDigitizationModal from "@/views/Task/TaskDigitizationModal.vue";
import ProjectModule from "@/store/modules/project";
import ApiEmailAutomationPlaceholders from "../../api/email_automation/placeholders";
import UserButton from "@/components/UsersField/UserButton.vue";

export default {
    name: "TaskView",
    components: {
        UserButton,
        SelectedUsersMobile,
        SelectedUsersDesktop,
        ChecklistField,
        ClientsField,
        ProjectField,
        RelatedTaskField,
        TopicsField,
        FollowersField,
        RecurrenceField,
        WorkflowDateField,
        CustomField,
        TaskInfoList,
        TaskAutomationList,
        PersonAvatar,
        AttachmentsList,
        TaskAddCommentControl,
        TaskTimeEntriesControl,
        TaskTimerControl,
        ClientAvatarListItem,
        TaskTitleComponent,
        TaskHeaderButtons,
        TaskNotes,
        TaskMobileToolbar,
        TaskAssignees,
        MagicButtonSettings,
        TaskSnoozeMenu,
        AddUserButton,
        TaskEstimation,
        SecondaryCheckbox,
        ProjectStatusField,
        TaskAddEmailControl,
        TaskDigitizationModal,
        TaskBillBy
    },
    props: {
        taskId: {
            type: [String, Number],
            required: true
        },
        isTemplate: {
            type: Boolean,
            default: false
        },
        clientId: {
            type: Number,
            default: 0
        },
        companyId: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ""
        },
        date: {
            type: String,
            default: null
        },
        topicId: {
            type: Number,
            default: null
        },
        isJobTemplate: {
            type: Boolean,
            default: false
        },
        isWorkflowTemplate: {
            type: Boolean,
            default: false
        },
        isFullPage: {
            type: Boolean,
            default: false
        },
        isTemporaryClientTask: {
            type: Boolean,
            default: false
        },
        temporaryClientTask: {
            type: Object,
            required: false,
            default: null
        },
        availableRelatedTasks: {
            type: Array,
            default: () => []
        },
        isTaskButton: {
            type: Boolean,
            default: false
        },
        pseudoUsers: {
            type: Array,
            default: () => []
        },
        timeEntry: {
            type: Object,
            default: null
        },
        projectId: {
            type: Number,
            default: null
        },
        isCpTemplate: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const router = Router();
        const {
            current_task,
            /*
            available_related_tasks,
             */
            closeTask,
            openTask,
            loadTask,
            postTask,
            saveTaskField,
            deleteTask,
            autoSuggestTasks,
            task_dialog,
            tasks_list
        } = TaskModule();
        const {fetchEmailAutomationTemplates} = EmailAutomationModule()
        const {current_account, isBundle, isFeatureEnabled, getAccount, available_account_for_clients} = AccountModule();
        const {fetchTaskButtons, taskButtons} = TaskButtonModule();
        const timerModule = TimerModule();
        const appModule = AppModule();
        const userModule = UserModule();
        const {isEventTypeCompany} = ProjectModule();
        const {cpFetchUsers} = ClientModule();
        const dialogModule = DialogModule();
        const title_edit = ref(false);
        const form_data = ref(null);
        const classifiers_loaded = ref(false);
        const footer_action = ref(null);
        const auto_save = ref(false);
        const new_task = ref(false);
        const formContentRef = ref(null);
        const estimations_menu = ref(false);
        const autoFocusField = ref("");
        const isAutoFocusSet = ref(false);
        const taskViewCard = ref(null);
        const relatedTasks = ref([]);
        const blockedRelatedTaskIds = ref([]);
        const digitizationEmail = ref(null)
        const isDigitizationModalOpen = ref(false)

        const saveLoading = ref(false);
        const startLoading = ref(false);
        const completeLoading = ref(false);
        const cp_users = ref([]);
        const cp_users_count = computed(() => cp_users.value.length)
        const editingAutomationIndex = ref(null);

        const titleField = ref(null);
        const clientField = ref(null);
        const assigneesField = ref(null);
        const cpAssigneesField = ref(null);
        const recurrenceRuleField = ref(null);
        const taskNotes = ref(null);
        const topicField = ref(null);
        const estimationField = ref(null);
        const saveButton1 = ref(null);
        const saveButton2 = ref(null);
        const userfile735 = ref(null);
        const emailContacts = ref([]);
        let filterDependantTasksTimeout = null;

        const dependsOnVisible = ref(false)
        const projectVisible = ref(false)
        const { getPlaceholderTypes } = ApiEmailAutomationPlaceholders

        let rollbackVal = null;

        form_data.value = {
            title_edit: false,
            title_error: null,
            client_id_error: null,
            description_error: null,
            description_edit: false,
            assignees_error: null,
            followers_error: null,
            date_error: null,
            depends_on_error: null,
            recurrence_rule_error: null,
            topic_id_show: false,
            bill_by_show: false,
            topic_id_error: null,
            fields: [],
            files: [],
            files_error: false,
            estimation_show: false,
            estimation_f: "",
            estimation_error: null,
            comment_attachments: [],
            time_entry: null,
            cp_assignees_error: null,
            cp_is_task_error: null,
            cp_auto_finish_error: null,
            task_button_description_error: null,
            task_button_description_edit: false
        };

        const TASK_FOOTER_ACTIONS = {
            ADD_COMMENT: 'add_comment',
            ADD_MESSAGE: 'add_message',
            ADD_EMAIL: 'add_email',
            MANAGE_TIME_ENTRIES: 'manage_time_entries'
        }

        const task_orig_client = ref(null);

        const isEmailingOnlyAutomations = computed(() => props.isTemplate || task_data.value.recurrence_rule !== null)

        const emailingEnabled = computed(() => {
            if (props.isTaskButton) return false;
            if (!task_data.value.account_id) return false;

            return isFeatureEnabled(task_data.value.account_id, APP_STORE_APP_TYPES.EMAILING, false);
        })

        const emailingPlaceholderTypes = computed(() => {
            const placeholderTypes = getPlaceholderTypes("task_default")
            if (task_data.value.project_id || props.isTemplate) {
                placeholderTypes.push(EMAIL_AUTOMATION_PLACEHOLDER_TYPES.PROJECT)
            }

            // Signatures
            if (props.isTemplate) {
                placeholderTypes.push(EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TEMPLATE_SIGNATURE)
            } else {
                placeholderTypes.push(EMAIL_AUTOMATION_PLACEHOLDER_TYPES.SIGNATURE)
            }
            return placeholderTypes
        })

        const projectsEnabled = computed(() => {
            if (!task_data.value.account_id) return false;
            return isFeatureEnabled(task_data.value.account_id, "project", false);
        });

        const billingEnabled = computed(() => {
            if (!task_data.value.account_id) return false;
            return isFeatureEnabled(task_data.value.account_id, "billing", false);
        });

        const projectEnabled = computed(() => {
            if (!projectsEnabled.value) return false;
            if (props.isJobTemplate) return false;
            if (props.isTemporaryClientTask && !task_data.value.project_id) return false;
            if (task_data.value.recurrence_rule != null) return false;
            if (task_data.value.recurrence_id) return false;
            return true;
        })
        const content_height = computed(function () {
            return props.isFullPage ? "{0}px".format(window.innerHeight - 56 - 76) : "320px";
        });
        const task_data = computed(() => {
            return props.isTemporaryClientTask ? props.temporaryClientTask : current_task.value;
        });

        const originally_is_cp = ref(false)
        const originally_has_cp_assignees = ref(false)
        const {showFeedbackNotification} = FeedbackNotificationModule();
        const handleTaskSentoToCP = () => {
            if ((!originally_is_cp.value || !originally_has_cp_assignees.value) && task_data.value && task_data.value.cp_is_task && task_data.value.cp_assignees.length > 0) {
                // originally the task wasn't available in CP, but now it is, so let's notify via snackbar
                originally_is_cp.value = true
                originally_has_cp_assignees.value = true
                showFeedbackNotification($t('Task sent to client portal'))
            } else if (originally_is_cp.value && originally_has_cp_assignees.value && task_data.value && !task_data.value.cp_is_task) {
                // reset
                originally_is_cp.value = false
                showFeedbackNotification($t('Task no longer assigned to client portal'))
            }
        }

        const save_button_text = computed(function () {
            if (task_data.value.recurrence_rule == null || props.isFullPage)
                return task_data.value.id === 0 && !props.isTemporaryClientTask ? $t("Add") : $t("Save");
            else
                return task_data.value.id === 0 && !props.isTemporaryClientTask
                    ? $t("Add recurring task")
                    : $t("Save recurring task");
        });
        const save_button_tooltip_text = computed(() => {
            if (task_data.value.recurrence_rule == null || props.isFullPage) {
                if (task_data.value.id === 0 && !props.isTemporaryClientTask) {
                    return $t("Add to-do list");
                }
            }
        })
        const own_client_id = computed(function () {
            return (
                appModule.clients.value[current_account.value.id].find(
                    c => c.account_id === current_account.value.id && c.is_account === 1
                ).id || 0
            );
        });
        const isGeneralTemplate = computed(() => {
            return props.isJobTemplate || props.isWorkflowTemplate;
        });
        const hasWorkflowDateRule = computed(() => {
            if (task_data.value.project_id) return true;
            return (task_data.value.fields && task_data.value.fields.workflow_date_rule);
        });

        const clients = computed(function () {
            let clients = [];

            if (task_data.value) {
                for (let i in appModule.clients.value) {
                    clients = clients.concat(
                        appModule.clients.value[i].filter(x => x.status === "active" && (available_account_for_clients.value.map(a => a.id).includes(x.account_id) || x.is_person) || x.id === task_data.value.client_id)
                    );
                }
            }

            if (props.isTaskButton && props.companyId) {
                clients = clients.filter(client => client.account_id === props.companyId)
            }

            if (task_orig_client.value != null) {
                if (clients.filter(x => x.id === task_orig_client.value.id).length === 0) {
                    clients.push({
                        id: task_orig_client.value.id,
                        name: task_orig_client.value.name,
                        client_initials: task_orig_client.value.client_initials,
                        color: task_orig_client.value.color
                    });
                }
            }

            clients = clients.filter(client => {
                const companyAccount = getAccount(client.account_id).value
                return companyAccount ? isFeatureAllowed(FEATURE_ADD_TASK_CLIENT, companyAccount) : true
            })

            return clients.sort(function (a, b) {
                if (a.is_person > b.is_person) return -1;
                if (a.is_person < b.is_person) return 1;

                if (a.is_account > b.is_account) return -1;
                if (a.is_account < b.is_account) return 1;

                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        })
        const users = computed(() => {
            if (!task_data.value.account_id) {
                return [current_account.value];
            }

            let tmp_users = userModule.getVisibleMembersByCompany(task_data.value.account_id)

            if (props.pseudoUsers.length > 0) {
                tmp_users = tmp_users.concat(props.pseudoUsers.filter(x => x.account_id === task_data.value.account_id));
            }

            let type_sort = {group: 1, field: 2, person: 3};
            return tmp_users.sort(function (a, b) {
                if (a.type !== b.type) {
                    if (type_sort[a.type] < type_sort[b.type]) return -1;
                    if (type_sort[a.type] > type_sort[b.type]) return 1;
                    return 0;
                }
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        });
        const curAvailableRelatedTasks = computed(() => {
            let tasks

            if (props.isTemporaryClientTask)
                tasks = props.availableRelatedTasks;
            else
                tasks = relatedTasks.value ? relatedTasks.value : [];

            const allTasks = tasks

            const recurrence_rule_type = task_data.value.recurrence_rule ? task_data.value.recurrence_rule['type'] : null
            if (recurrence_rule_type) {
                tasks = tasks.filter(x => x.recurrence_rule && x.recurrence_rule['type'] === recurrence_rule_type)
            } else {
                tasks = tasks.filter(x => !x.recurrence_rule)
            }

            if (!auto_save.value) {
                tasks = tasks.filter(x => {
                    if (recurrence_rule_type === 'weekly') {
                        const main_task_max_week = Math.max(task_data.value.recurrence_rule['weekdays'])
                        const depends_on_task_max_week = Math.max(x.recurrence_rule['weekdays'])

                        if (main_task_max_week < depends_on_task_max_week) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'monthly') {
                        const main_task_day_of_month = task_data.value.recurrence_rule['day_of_month']
                        const depends_on_task_day_of_month = x.recurrence_rule['day_of_month']

                        if (main_task_day_of_month < depends_on_task_day_of_month) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'quarterly') {
                        const main_task_monthly_period = task_data.value.recurrence_rule['month_of_period']
                        const main_task_day_period = task_data.value.recurrence_rule['day_of_month']

                        const depends_on_task_monthly_period = x.recurrence_rule['month_of_period']
                        const depends_on_task_day_period = x.recurrence_rule['day_of_month']

                        if (main_task_monthly_period < depends_on_task_monthly_period) {
                            return false
                        } else if ((main_task_monthly_period === depends_on_task_monthly_period) && (main_task_day_period < depends_on_task_day_period)) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'yearly') {
                        const main_task_monthly_period = task_data.value.recurrence_rule['month_of_period']
                        const main_task_day_period = task_data.value.recurrence_rule['day_of_month']

                        const depends_on_task_monthly_period = x.recurrence_rule['month_of_period']
                        const depends_on_task_day_period = x.recurrence_rule['day_of_month']

                        if (main_task_monthly_period < depends_on_task_monthly_period) {
                            return false
                        } else if ((main_task_monthly_period === depends_on_task_monthly_period) && (main_task_day_period < depends_on_task_day_period)) {
                            return false
                        }
                    }

                    return true
                })
            }

            if (task_data.value.depends_on) {
                for (const dependsOnId of task_data.value.depends_on) {
                    if (!tasks.find(x => x.id === dependsOnId)) {
                        const task = allTasks.find(x => x.id === dependsOnId)
                        if (task) {
                            tasks.push(task)
                        }
                    }
                }
            }

            tasks = tasks.filter(x => !blockedRelatedTaskIds.value.includes(x.id))

            return tasks
        });
        const topics = computed(function () {
            if (!task_data.value.account_id) return [];
            if (appModule.topics.value[task_data.value.account_id] === undefined) return [];

            return appModule.topics.value[task_data.value.account_id].sort(function (a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        });
        const custom_fields = computed(function () {
            if (!task_data.value.account_id) return [];
            if (appModule.custom_fields.value[task_data.value.account_id] === undefined) return [];

            return appModule.custom_fields.value[task_data.value.account_id]
                .filter(function (x) {
                    return x.related_type === "task";
                })
                .sort(function (a, b) {
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                });
        });

        const isCustomFieldRequired = (customField) => {
            if (customField._data && customField.required && customField._data.required_type === 'selected') {
                if (customField._data.required_ids.includes(task_data.value.topic_id)) {
                    return true
                }
            } else if (customField.required) {
                return true
            }

            return false
        }

        const form_data_fields = computed(() => {
            let fields = form_data.value.fields ? form_data.value.fields.filter(x => x.field !== undefined) : [];

            for (const customField of custom_fields.value) {

                if (isCustomFieldRequired(customField) && !fields.find(x => x.name === customField.name)) {
                    fields.push({
                        name: customField.name,
                        value: null,
                        field: customField
                    })
                }
            }

            return fields
        });
        const show_topic = computed(function () {
            return form_data.value.topic_id_show || task_data.value.topic_id !== null;
        });

        const show_bill_by = computed(() => {
            return form_data.value.bill_by_show || task_data.value.bill_by
        })

        const header_class = computed(function () {
            return task_data.value.recurrence_rule == null ? "" : "header-template";
        });
        const fields = computed(function () {
            if (task_data.value == null) return null;
            return task_data.value.fields;
        });
        const automations = computed(function () {
            if (task_data.value == null) return [];
            return task_data.value.automations ? task_data.value.automations : [];
        });
        const files = computed(function () {
            if (task_data.value == null) return null;
            return task_data.value.files;
        });
        const estimation = computed(function () {
            if (task_data.value == null) return null;
            return task_data.value.estimation;
        });
        const client_id = computed(function () {
            if (task_data.value == null) return null;
            return task_data.value.client_id;
        });
        const topic_id_error = computed(function () {
            return form_data.value.topic_id_error;
        });
        const recurrence_rule_error = computed(() => {
            if (form_data.value.date_error) return form_data.value.date_error;
            if (form_data.value.recurrence_rule_error) return form_data.value.recurrence_rule_error;
            return null;
        });
        const workflow_date_rule_error = computed(() => {
            if (form_data.value.date_error) return form_data.value.date_error;
            if (form_data.value.fields && form_data.value.fields.workflow_date_rule_error)
                return form_data.value.fields.workflow_date_rule_error;
            return null;
        });
        const client_enabled = computed(function () {
            // recurrent tasks
            if (task_data.value.recurrence_id !== undefined && task_data.value.recurrence_id != null) return false;
            // update task templates
            if (task_data.value.recurrence_rule != null && task_data.value.id !== 0) return false;
            // if under client plan
            if (props.isTemporaryClientTask) return false;
            // if project task
            if (task_data.value.project_id && task_data.value.id)
                return false;
            // Email edit view is open
            if (footer_action.value === TASK_FOOTER_ACTIONS.ADD_EMAIL) return false;
            // other cases
            return true;
        });
        const project_enabled = computed(() => {
            // in case of workflow plan
            if (props.isTemporaryClientTask)
                return false;
            // in case of saved task
            if (task_data.value.id)
                return false;
            return true;
        });
        const comment_enabled = computed(function () {
            return (
                (task_data.value.id !== 0 || task_data.value.virtual_id !== 0) &&
                task_data.value.recurrence_rule === null && !props.isTaskButton &&
                !props.isWorkflowTemplate
            );
        });
        const show_footer = computed(function () {
            return (!auto_save.value || comment_enabled.value || props.isTemporaryClientTask || props.isTaskButton) && !footer_action.value;
        });
        const show_timer = computed(function () {
            if (props.isTemporaryClientTask) return false;
            if (props.isTaskButton) return false;
            return task_data.value.recurrence_rule == null;
        });
        const taskErrors = computed(() => {
            if (!task_data.value.account_id) return [];
            if (appModule.custom_fields.value[task_data.value.account_id] === undefined) return [];

            let ret = [];
            if (task_data.value.id && task_data.value.project && task_data.value.project_status_from) {
                let fld = appModule.custom_fields.value[task_data.value.account_id].find(x => x.type === "project_status");

                if (fld != null && fld._data && fld._data.choices !== undefined) {
                    let steps = fld._data.choices.map(x => x.code);
                    let project_step = steps.indexOf(task_data.value.project.status);
                    let task_step = steps.indexOf(task_data.value.project_status_from);
                    if (project_step > -1 && task_step > -1 && task_step > project_step) {
                        const text = isEventTypeCompany(task_data.value.account_id) ? $t("Waiting for event status: {0}") : $t("Waiting for project status: {0}")

                        ret.push(text.format(fld._data.choices.find(x => x.code === task_data.value.project_status_from).name));
                    }
                }
            }

            return ret;
        });

        const isTaskRunning = computed(function () {
            if (!show_timer.value) return false;
            let task_id = parseInt(timerModule.task_id.value)
            return task_data.value.id === task_id && timerModule.status.value === "running";
        });
        const timer_time = computed(function () {
            if (!show_timer.value) return 0;

            // if new task take time from form data
            if (task_data.value.id === 0) {
                if (form_data.value.time_entry != null) {
                    let start = parseSysDateTime(form_data.value.time_entry.start);
                    let end =
                        form_data.value.time_entry.end == null
                            ? new Date()
                            : parseSysDateTime(form_data.value.time_entry.end);
                    return (end.getTime() - start.getTime()) / 1000;
                }
                return 0;
            }

            // if running task take time from timer
            if (isTaskRunning.value) {
                return (
                    timerModule.total_duration.value +
                    timerModule.running_duration.value +
                    timerModule.ticking_duration.value
                );
            }

            // if existing not running task take time from task data
            if (task_data.value == null || task_data.value.id === 0 || task_data.value.tracked_time == null) return 0;
            let acc_id_str = current_account.value.id.toString();
            return task_data.value.tracked_time[acc_id_str] === undefined
                ? 0
                : task_data.value.tracked_time[acc_id_str];
        });
        const running_time = computed(function () {
            return isTaskRunning.value ? timerModule.running_duration.value + timerModule.ticking_duration.value : 0;
        });
        const task_title = computed(() => (task_data.value == null ? null : task_data.value.title));
        const clientPortalEnabled = computed(() => {
            // do not allow CP for task buttons, at least for now
            if (props.isTaskButton || (task_data.value.task_button && task_data.value.task_button.id)) return false;
            if (!task_data.value.account_id) return false;
            return isFeatureEnabled(task_data.value.account_id, "client_portal", false)
        });
        const clientPortalVisible = computed(() => {
            if (props.isCpTemplate) {
                return false
            }

            if (!clientPortalEnabled.value) {
                return false
            }

            return (cp_users_count.value > 0 || props.isJobTemplate || props.isWorkflowTemplate)
        })
        const clientName = computed(() => {
            if (!task_data.value.client_id) return "";
            let cli = clients.value.find(x => x.id === task_data.value.client_id);
            return cli == null ? "" : cli.name;
        });

        const getLoadTaskParams = function () {
            let params = {}

            if (props.taskId === 0) {
                if (props.clientId) params.client_id = props.clientId;
                if (props.projectId) params.project_id = props.projectId;
                if (props.title) params.title = props.title;
                if (props.topicId) params.topic_id = props.topicId;
                if (props.date) params.date = props.date;
                if (props.isTemplate) params.is_template = props.isTemplate;
            } else {
                if (props.isTemplate) params.action = "task_to_template";
            }
            /*
            params.load_available_related_tasks = "1"
             */
            return params;
        }

        const handleLoadTaskResponse = function () {
            form_data.value.topic_id_show = !!task_data.value.topic_id;
            form_data.value.estimation_show = !!task_data.value.estimation;

            if (task_data.value.depends_on && task_data.value.depends_on.length) {
                dependsOnVisible.value = true
            }

            if (task_data.value.project_id) {
                projectVisible.value = true
            }

            if (form_data.value.estimation_show)
                form_data.value.estimation_f = formatTimeDuration(task_data.value.estimation);
            auto_save.value =
                (task_data.value.id || task_data.value.virtual_id) &&
                !task_data.value.recurrence_rule &&
                !props.isTemporaryClientTask;
            new_task.value = !task_data.value.id && !task_data.value.virtual_id;
            if (task_data.value.client)
                task_orig_client.value = Vue.clone_object(task_data.value.client);
            load_custom_fields();
            updateRelatedTasks()
            originally_is_cp.value = !!current_task.value.cp_is_task
            originally_has_cp_assignees.value = current_task.value.cp_assignees && task_data.value.cp_assignees.length > 0
        }

        const loadClassifiers = function () {
            let classifiers_types = props.isJobTemplate
                ? ["topics", "custom_fields", "languages", "roles", "clients"]
                : ["topics", "custom_fields", "clients", "languages", "roles"];

            userModule.loadMembers()
            appModule
                .fetchClassifiers({
                    types: classifiers_types
                })
                .then(function () {
                    classifiers_loaded.value = true;
                    load_custom_fields();
                    load_files();
                })
                .catch(function (ex) {
                    errorDialog.showError(ex);
                });
        }

        const load_data = function () {
            appModule.setMiniUkuNoFooter(false);
            blockedRelatedTaskIds.value = []

            loadClassifiers()

            if (props.isTemporaryClientTask) {
                task_orig_client.value = props.temporaryClientTask.client;

                if (props.temporaryClientTask.depends_on && props.temporaryClientTask.depends_on.length) {
                    enable_depends_on()
                }

                if (task_data.value.project_id && !props.isWorkflowTemplate) {
                    enable_project()
                }

                fetchEmailAutomationTemplates(task_data.value.account_id)
                return;
            }

            let params = getLoadTaskParams()

            loadTask(props.taskId, params)
                .then(function () {
                    handleLoadTaskResponse()
                    fetchEmailAutomationTemplates(task_data.value.account_id)
                })
                .catch(function (ex) {
                    closeTask()
                    errorDialog.showError(ex);
                });
        };
        const load_custom_fields = function () {
            form_data.value.fields = [];

            if (!task_data.value || !classifiers_loaded.value) return;
            if (task_data.value.fields == null) return;

            for (let prop in task_data.value.fields) {
                if (Object.prototype.hasOwnProperty.call(task_data.value.fields, prop)) {
                    let custom_field = custom_fields.value.filter(x => x.name === prop);
                    if (custom_field.length > 0) {
                        form_data.value.fields.push({
                            name: custom_field[0].name,
                            field: custom_field[0],
                            value: task_data.value.fields[prop]
                        });
                    }
                }
            }
        };

        const cp_assignees_data = computed(() => {
            if (task_data.value == null) return []
            return task_data.value.cp_assignees_data
        })

        const load_client_portal_users = () => {
            if (task_data.value == null) return;

            if (!clientPortalEnabled.value || !task_data.value.client_id) {
                cp_users.value = [];
                return;
            }

            cpFetchUsers(task_data.value.client_id)
                .then(resp => {
                    if (cp_assignees_data.value) {
                        resp.forEach(updateCPAssigneesData)
                    }

                    cp_users.value = resp;
                })
                .catch(ex => errorDialog.showError(ex));
        };

        const resetTaskIsSeenForCPAssignees = function () {
            if (!cp_users.value) return
            cp_users.value.forEach((x) => x.is_seen = false)
        }

        const updateCPAssigneesData = function (cpUser) {
            const _data = cp_assignees_data.value.find((x) => x.assigned_id === cpUser.id)
            if (_data) {
                cpUser.is_seen = _data.is_seen
                cpUser.finished = _data.finished
            }
        }

        watch(cp_assignees_data, () => {
            if (cp_users.value)
                cp_users.value.forEach(updateCPAssigneesData)
        }, {immediate: false})

        const load_files = function () {
            if (task_data.value == null || task_data.value.files == null) {
                form_data.value.files = [];
                return;
            }

            let file_id_list = task_data.value.files.map(x => x.id);
            let delete_id_list = form_data.value.files
                .filter(x => x.id > 0 && file_id_list.indexOf(x.id) === -1)
                .map(x => x.id);

            for (let i = form_data.value.files.length - 1; i >= 0; i--) {
                let f = form_data.value.files[i];
                if (f.id > 0 && delete_id_list.indexOf(f.id) >= 0) {
                    form_data.value.files.splice(i, 1);
                }
            }

            for (let i in task_data.value.files) {
                let f = task_data.value.files[i];
                let found = false;

                for (let j = 0; j < form_data.value.files.length; j++) {
                    let local_f = form_data.value.files[j];
                    if (local_f.id === 0) {
                        if (local_f.uploading && local_f.file_name === f.file_name) {
                            local_f.id = f.id;
                            local_f.temp_id = null;
                            local_f.temp_name = null;
                            local_f.uploading = false;
                            local_f.progress = 100;
                            found = true;
                            break
                        }
                    } else {
                        if (local_f.id === f.id) {
                            found = true;
                            break
                        }
                    }
                }

                if (!found) {
                    form_data.value.files.push({
                        id: f.id,
                        file_name: f.file_name,
                        size: f.size,
                        is_deleted: f.is_deleted,
                        uploading: f.uploading === undefined ? false : f.uploading,
                        progress: f.progress === undefined ? 100 : f.progress,
                        temp_id: f.temp_id === undefined ? null : f.temp_id,
                        temp_name: f.temp_name === undefined ? null : f.temp_name
                    });
                }
            }
        };
        const taskHasValidIdOrVirtualId = function () {
            const hasStrangeTempId = typeof task_data.value.id === 'string' && task_data.value.id.startsWith('tmp')
            const hasValidId = task_data.value.id !== 0
            const hasVirtualId = task_data.value.id === 0 && task_data.value.virtual_id !== 0

            return !hasStrangeTempId && (hasValidId || hasVirtualId)
        }
        const taskHasRecurrence = function () {
            return task_data.value.recurrence_id !== undefined &&
                task_data.value.recurrence_id != null &&
                task_data.value.recurrence_id !== 0
        }

        const menu_items = computed(() => {
            let tmp = [];

            if (taskHasValidIdOrVirtualId()) {
                if (taskHasRecurrence())
                    tmp.push({action: "open_template", title: $t("Edit template task")});
                else {
                    if (task_data.value.recurrence_rule == null && !props.isTaskButton && !task_data.value.project_id)
                        tmp.push({action: "create_template", title: $t("Create recurring task")});
                }
            }

            tmp.push({action: 'enable_depends_on', title: $t('Add dependency')})
            tmp.push({action: "enable_estimation", title: $t("Add estimation")});
            tmp.push({action: "add_custom_field", title: $t("Add task field")});

            if (billingEnabled.value) {
                {
                    tmp.push({action: "enable_bill_by", title: $t("Billing")});
                }
            }

            if (projectEnabled.value && !task_data.value.id && !task_data.value.recurrence_rule) {
                tmp.push({action: 'enable_project', title: isEventTypeCompany(task_data.value.account_id) ? $t('Add event') : $t('Add project')})
            }

            tmp.push({action: "add_attachment", title: $t("Add attachment")});

            if (task_data.value.id !== 0 && !props.isTemporaryClientTask && !props.isTaskButton) {
                tmp.push({action: "clone_template", title: $t("Make a copy")});
            }

            if (props.isFullPage) {
                tmp.push({action: "enable_topic", title: $t("Add topic")});
            }

            if (task_data.value.id !== 0 || (task_data.value.id === 0 && task_data.value.virtual_id !== 0)) {
                tmp.push({
                    action: "delete",
                    title: task_data.value.recurrence_rule == null ? $t("Delete task") : $t("Delete task template")
                });
            }

            return tmp;
        });

        onMounted(function () {
            if (props.taskId === 0) {
                focus_field("title");
            }
            // task messages are marked seen in activity component
        });

        const updateRelatedTasks = async (keyword = null) => {
            if (!dependsOnVisible.value) {
                return
            }

            if (!task_data.value.client_id) {
                return
            }

            if (props.isTemporaryClientTask) {
                return
            }

            const data = await ApiTask.getRelatedTasks(
                task_data.value.project_id,
                task_data.value.account_id,
                task_data.value.client_id,
                task_data.value.id,
                task_data.value.virtual_id,
                task_data.value.date,
                keyword
            )

            relatedTasks.value = data.related_tasks
        }

        function getRefs() {
            return {
                title: ref(titleField.value?.$refs?.titleField),
                client_id: clientField,
                assignees: assigneesField,
                recurrence_rule: recurrenceRuleField,
                description: ref(taskNotes?.value?.$refs?.descriptionField),
                topic_id: topicField,
                estimation: estimationField
            };
        }

        const focus_field = function (field_name) {
            let refs = getRefs();

            rollbackVal = form_data.value[field_name];
            form_data.value[field_name + "_edit"] = true;

            if (refs[field_name].value == null) {
                setTimeout(() => focus_field(field_name), 50);
            } else {
                if (refs[field_name].value && refs[field_name].value.focus) {
                    refs[field_name].value.focus();
                }
            }
        };
        const focus_next = function (field_name, exact = false) {
            let refs = getRefs();

            refs[field_name].value.blur();
            if (auto_save.value) return;

            let tabPath = ["title", "client_id", "assignees", "recurrence_rule"];
            let idx = tabPath.indexOf(field_name) + (exact ? 0 : 1);

            if (idx < tabPath.length) {
                focus_field(tabPath[idx]);
            } else {
                if (saveButton1.value != null) saveButton1.value.$el.focus();
                if (saveButton2.value != null) saveButton2.value.$el.focus();
            }
        };
        const add_comment = function () {
            openFooterAction(TASK_FOOTER_ACTIONS.ADD_COMMENT)
        };
        const add_message_or_comment = function () {
            openFooterAction(TASK_FOOTER_ACTIONS.ADD_MESSAGE)
        }
        const close_comment = function () {
            footer_action.value = null;
            form_data.value.comment_attachments = [];
            form_data.value.comment_attachments = [];
        };
        const close_email = () => {
            editingAutomationIndex.value = null;
            footer_action.value = null;
        }

        const manage_time_entries = function () {
            openFooterAction(TASK_FOOTER_ACTIONS.MANAGE_TIME_ENTRIES)
            appModule.setMiniUkuNoFooter(true);
        };
        const close_time_entries = function () {
            appModule.setMiniUkuNoFooter(false);
            footer_action.value = null;
        };
        const toggle_field = function (field_name) {
            task_data.value[field_name] = task_data.value[field_name] ? 0 : 1;
            set_and_save_field(field_name);
        };

        const set_and_save_field = function (field_name, val = null) {
            const payload = {}
            payload[field_name] = set_field(field_name, val)
            save_field(payload, "TaskView.set_and_save_field")
        }

        const saveProjectId = (event) => {
            const id = event ? event.id : null

            set_and_save_field('project_id', id)
            // Note: setting just task_data.value.project = taskDataCopy is not always reactive
            // currently left this ugly hack
            const taskDataCopy = {...task_data.value}
            taskDataCopy.project = event
            if (props.isTemporaryClientTask) {
                props.temporaryClientTask = taskDataCopy
            } else {
                current_task.value = taskDataCopy
            }

            updateRelatedTasks()
        }

        const save_field = async function (payload, debug_name) {
            if (!auto_save.value) return

            payload.id = task_data.value.id
            payload.virtual_id = task_data.value.virtual_id
            payload = sanitize_payload(payload)
            try {
                await saveTaskField(payload, debug_name)

                if (!payload.id) {
                    await updateRelatedTasks()
                } else {
                    handleTaskSentoToCP()
                }

            } catch (ex) {
                if (payload.cp_is_task) set_field('cp_is_task', 0)
                handleCircularDependencyError(ex)
                appModule.handleErrorResponse(form_data.value, ex);
            }
        }

        const handleCircularDependencyError = (ex) => {
            if (ex.response.data.error_type !== 'form_validation') {
                return
            }

            const circularDependencyError = ex.response.data.errors.find(x => x.field === 'depends_on')
            if (circularDependencyError && circularDependencyError.task_id) {
                blockedRelatedTaskIds.value.push(circularDependencyError.task_id)

                if (task_data.value.depends_on) {
                    task_data.value.depends_on = task_data.value.depends_on.filter(x => !blockedRelatedTaskIds.value.includes(x))
                }
            }
        }

        const set_field = function (field_name, val = null) {
            clear_field_state(field_name)
            rollbackVal = null;

            if (field_name === "topic_id" || field_name === "follow" || field_name === "project_id" || field_name === "project_status_from" || field_name === "depends_on") {
                task_data.value[field_name] = val;
            }

            if (field_name === "is_cp") {
                task_data.value.is_cp = 1;
                set_and_save_field('cp_is_task', true)
                task_data.value.cp_assignees = [];
                setTimeout(() => cpAssigneesField.value.$children[0].menu_open = true, 250)
            }
            if (field_name === "cp_is_task") {
                task_data.value.cp_is_task = val
                if (!task_data.value.cp_is_task && task_data.value.cp_auto_finish)
                    set_and_save_field('cp_auto_finish', 0)
            }
            if (field_name === "cp_auto_finish") {
                task_data.value.cp_auto_finish = task_data.value.cp_auto_finish ? 0 : 1;
            }

            if (field_name === "assignees") {
                task_data.value.assignees = val
            }

            if (field_name === "followers") {
                task_data.value.followers = val
            }

            if (field_name === "cp_assignees") {
                task_data.value.cp_assignees = val
                const _now = task_data.value.cp_assignees.length > 0;
                if (!_now)
                    set_and_save_field('cp_is_task', _now)
            }

            if (field_name === 'cp_due_date_offset') {
                task_data.value.cp_due_date_offset = val
            }

            if (field_name === 'automations') {
                task_data.value.automations = val
            }

            return task_data.value[field_name] === undefined ? null : task_data.value[field_name];
        };

        const clear_field_state = function (field_name) {
            let edit_key = field_name + "_edit";
            if (form_data.value[edit_key] !== undefined) form_data.value[edit_key] = false;

            let error_key = field_name + "_error";
            if (form_data.value[error_key] !== undefined) form_data.value[error_key] = null;
        }
        const sanitize_payload = function (data) {
            for (const key in Object.keys(data)) {
                if (typeof data[key] === "string") {
                    data[key] = data[key].trim();
                }
            }
            return data
        }

        const keep_only_me = function ({keep, remove}) {
            const new_followers = task_data.value.followers
                .concat(remove)
                .filter((value, index, self) => self.indexOf(value) === index)

            const payload = {}
            payload['assignees'] = set_field('assignees', keep)
            payload['followers'] = set_field('followers', new_followers)
            save_field(payload, "TaskView.set_and_save_field")

        };
        const save_recurrence_field = function (val) {
            clear_field_state("recurrence_rule")

            let data = {id: task_data.value.id, virtual_id: task_data.value.virtual_id};

            if (!val) {
                data.recurrence_rule = null;
                data.date_only = task_data.value.date_only;
                data.has_due_date = task_data.value.has_due_date;
                data.due_date = task_data.value.due_date;
                data.due_date_only = task_data.value.due_date_only;
                data.recurrence_rule = null;
            } else {
                rollbackVal = null;
                data["date_only"] = val.date_only ? 1 : 0;
                data["date"] = val.date_only ? val.date + " 00:00:00" : "{0} {1}".format(val.date, val.time);
                data["has_due_date"] = val.has_due_date ? 1 : 0;
                if (val.type === "date") {
                    data["recurrence_rule"] = null;

                    if (val.has_due_date) {
                        data["due_date_only"] = val.due_date_only ? 1 : 0;
                        data["due_date"] = val.due_date_only
                            ? val.due_date + " 23:59:59"
                            : "{0} {1}".format(val.due_date, val.due_time);
                    } else {
                        data["due_date_only"] = data["date_only"];
                        data["due_date"] = val.date_only ? val.date + " 23:59:59" : "{0} {1}".format(val.date, val.time);
                    }
                } else if (val.type === "wf_date") {
                    let d = new Date();
                    data["recurrence_rule"] = val;
                    data["date_only"] = 1;
                    data["date"] = "{0}-{1}-{2} 00:00:00".format(d.getFullYear(), (d.getMonth() + 1).pad(2), d.getDate().pad(2));
                    data["due_date_only"] = 1;
                    data["due_date"] = data["date"];
                } else {
                    data["recurrence_rule"] = val;
                    data["due_date_only"] = data["date_only"];
                    data["due_date"] = data["date"];
                }
            }

            if (!auto_save.value) {
                task_data.value.date = data.date;
                task_data.value.date_only = data.date_only;
                task_data.value.has_due_date = data.has_due_date;
                task_data.value.due_date = data.due_date;
                task_data.value.due_date_only = data.due_date_only;
                //task_data.value.due_date = data.due_date;
                task_data.value.recurrence_rule = data.recurrence_rule;

                if (props.isTemporaryClientTask && task_data.value.depends_on) {
                    task_data.value.depends_on = task_data.value.depends_on.filter(x => curAvailableRelatedTasks.value.find(z => z.id === x))
                }

                return;
            }
            saveTaskField(data, "TaskView.save_recurrence_field").catch(function (ex) {
                appModule.handleErrorResponse(form_data.value, ex);
            });
        };
        const save_custom_field = function (field_name, val) {
            let found = false;
            for (let i = 0; i < form_data.value.fields.length; i++) {
                if (form_data.value.fields[i].name === field_name) {
                    form_data.value.fields[i].value = val;
                    found = true;
                    break;
                }
            }
            if (!found) {
                form_data.value.fields.push({
                    name: field_name,
                    value: val
                });
            }
            save_custom_fields(field_name, val);
        };
        const save_custom_fields = function (field_name) {
            let fields = {};
            if (form_data.value.fields.length > 0) {
                for (let i = 0; i < form_data.value.fields.length; i++) {
                    let fld = form_data.value.fields[i];
                    fields[fld.name] = fld.value;
                }
            }
            if (task_data.value.fields) {
                for (const fieldName in task_data.value.fields) {
                    if (fieldName.includes('_error')) {
                        fields[fieldName] = task_data.value.fields[fieldName]
                    }
                }
            }

            if (hasWorkflowDateRule.value && !fields['workflow_date_rule'] && task_data.value.fields && task_data.value.fields.workflow_date_rule) {
                fields['workflow_date_rule'] = task_data.value.fields.workflow_date_rule
            }

            if (field_name)
                fields[field_name + '_error'] = null

            if (!auto_save.value) {
                task_data.value.fields = fields;
                return;
            }

            let data = {id: task_data.value.id, virtual_id: task_data.value.virtual_id, fields: fields};
            saveTaskField(data, "TaskView.save_custom_fields")
                .then(() => {
                    // UKU-2600 :: todo metrics - read window
                    uku_send_event({event: UKU_ACTIVITIES.CUSTOM_FIELD_ACTIVATED, info: "task.saveTaskField"})
                })
                .catch(function (ex) {
                    appModule.handleErrorResponse(form_data.value, ex);
                });
        };
        const update_checklist_field = function (data) {
            task_data.value.checklist = data;
        };
        const client_changed = async (client_id) => {
            form_data.value.client_id_error = null;
            let accountChanged = false

            let data = {id: task_data.value.id, virtual_id: task_data.value.virtual_id, client_id: client_id, project_id: null, cp_assignees: []};
            if (client_id !== 0) {
                let account_id = clients.value.filter(x => x.id === client_id)[0].account_id;
                if (task_data.value.account_id !== account_id) {
                    //TODO: Might affect assignees, topics, custom fields, ...
                    task_data.value.account_id = clients.value.filter(x => x.id === client_id)[0].account_id;
                    data.account_id = account_id;
                    accountChanged = true
                }
            }

            handleClientChangeAutomations(accountChanged)

            if (auto_save.value) {
                try {
                    await saveTaskField(data, "TaskView.client_changed")
                } catch (ex) {
                    appModule.handleErrorResponse(form_data.value, ex)
                }
            } else {
                task_data.value.client_id = client_id;
                task_data.value.cp_assignees = [];
                task_data.value.project_id = null;
            }

            updateEmailContacts(client_id)
            updateRelatedTasks()
        };

        const handleClientChangeAutomations = (accountChanged) => {
            if (!accountChanged) {
                return
            }

            let automations = task_data.value.automations

            if (!emailingEnabled.value) {
                automations = []
            } else {
                automations = automations.filter(x => x.content_template_id === null)
            }

            set_and_save_field('automations', automations)
        }

        const time_field_changed = function (field_name, data) {
            form_data.value[field_name + "_error"] = null;

            if (!data) {
                task_data.value[field_name] = null;
            } else {
                let seconds = parseTimeDuration(data);

                if (seconds == null) {
                    form_data.value[field_name + "_error"] = $t("Incorrect time");
                    return;
                }

                task_data.value[field_name] = seconds;
            }

            set_and_save_field(field_name);
        };
        const estimation_select = function (seconds) {
            task_data.value.estimation = task_data.value.estimation === seconds ? null : seconds;
            form_data.value.estimation_f = formatTimeDuration(task_data.value.estimation);
            set_and_save_field("estimation");
        };
        const enable_topic = function () {
            form_data.value.topic_id_show = true;
            setTimeout(function () {
                focus_field('topic')
            }, 100);
        };

        const enable_bill_by = function () {
            form_data.value.bill_by_show = true;
            /*setTimeout(function () {
                focus_field('bill_by')
            }, 100);*/
        };

        const enable_estimation = function () {
            if (!task_data.value.account_id) return;
            if (!isBundle(task_data.value.account_id)) return;
            form_data.value.estimation_show = true;
            setTimeout(function () {
                focus_field('estimation')
                estimations_menu.value = true;
            }, 100);
        };
        const toggle_custom_field = function (custom_field, do_save = true) {
            let found = false;
            for (let i = 0; i < form_data.value.fields.length; i++) {
                if (form_data.value.fields[i].name === custom_field.name) {
                    form_data.value.fields.splice(i, 1);
                    found = true;
                    break;
                }
            }

            if (!found) {
                form_data.value.fields.push({
                    name: custom_field.name,
                    field: custom_field,
                    value: null
                });
            }

            if (do_save) save_custom_fields();
        };
        const open_custom_field_dialog = function () {
            let selected_fields = form_data.value.fields.map(x => x.name);

            dialogModule.setConfirmOptions({
                title: $t("Select task field"),
                options: custom_fields.value.map(function (x) {
                    const isRequired = isCustomFieldRequired(x)
                    let text = x.title
                    text = x.billable ? text : text + ' (' + $t('Non-billable') + ')'
                    text = isRequired ? text + ' *' : text
                    return {
                        name: x.name,
                        text: text,
                        checked: Boolean(isRequired) || selected_fields.indexOf(x.name) >= 0,
                        disabled: Boolean(isRequired),
                        billable: x.billable,
                    };
                }),
                text: (custom_fields.value.length < 1 && $t("No custom fields available for this client")) || null,
                confirm_text: $t("OK"),
                cancel_text: $t("Cancel"),
                action: function (field_names) {
                    let dirty = false;
                    for (let i = 0; i < selected_fields.length; i++) {
                        if (field_names.indexOf(selected_fields[i]) === -1) {
                            let custom_field = custom_fields.value.filter(x => x.name === selected_fields[i])[0];
                            if (custom_field) {
                                toggle_custom_field(custom_field, false);
                                dirty = true;
                            }
                        }
                    }
                    for (let i = 0; i < field_names.length; i++) {
                        if (selected_fields.indexOf(field_names[i]) === -1) {
                            let custom_field = custom_fields.value.filter(x => x.name === field_names[i])[0];
                            if (custom_field) {
                                toggle_custom_field(custom_field, false);
                                dirty = true;
                            }
                        }
                    }
                    if (dirty) save_custom_fields();
                }
            });

            dialogModule.openConfirmDialog();
        };

        const cancel_field = function (field_name) {
            form_data.value[field_name] = rollbackVal;
            form_data.value[field_name + "_edit"] = false;
        };

        const enable_depends_on = () => {
            dependsOnVisible.value = true
            updateRelatedTasks()
        }

        const enable_project = () => {
            projectVisible.value = true
        }

        const action_click = function (action) {
            switch (action) {
                case "delete":
                    delete_task();
                    break;
                case "open_template":
                    open_template();
                    break;
                case "create_template":
                    create_template();
                    break;
                case "enable_estimation":
                    enable_estimation();
                    break;
                case "enable_depends_on":
                    enable_depends_on()
                    break;
                case "enable_project":
                    enable_project()
                    break;
                case "enable_topic":
                    enable_topic();
                    break;
                case "add_custom_field":
                    open_custom_field_dialog();
                    break;
                case "enable_bill_by":
                    enable_bill_by();
                    break;
                case "add_attachment":
                    userfile735.value.click();
                    break;
                case "clone_template":
                    clone_template();
                    break;
            }
        };
        const get_assignees_names_list = function () {
            return friendlyJoin(
                users.value.filter(x => task_data.value.assignees.indexOf(x.id) >= 0 && x.id !== current_account.value.id).map(x => formatName(x)),
                ", ",
                ", "
            );
        };
        const delete_task = function () {
            let dialog_props = {
                title: "",
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: delete_task_confirmed
            };

            let task_type = task_data.value.recurrence_rule == null ? $t("task") : $t("recurring task");
            if (task_data.value.assignees.indexOf(current_account.value.id) >= 0) {
                if (task_data.value.assignees.length > 1) {
                    dialog_props.title = $t("Do you intend to remove yourself from {0} or you want to delete it completely?").format(task_type);
                    dialog_props.text = $t("This {1} is shared with {0}").format(get_assignees_names_list(), task_type);
                    dialog_props.confirm_text2 = $t("Remove only me");
                    dialog_props.action2 = remove_me_confirmed;
                    if (task_data.value.tracked_time && !!Object.keys(task_data.value.tracked_time).length > 0) {
                        dialog_props.action = confirm_delete;
                    }
                } else if (task_data.value.tracked_time && !!Object.keys(task_data.value.tracked_time).length > 0) {
                    dialog_props.title = $t("Time has been tracked to this task.") + " " + $t("Are you sure to delete this task?");
                } else {
                    dialog_props.title = $t("Are you sure to delete this task?");
                }
            } else if (task_data.value.tracked_time && !!Object.keys(task_data.value.tracked_time).length > 0) {
                dialog_props.title = $t("Time has been tracked to this task.") + " " + $t("Are you sure to delete this task?") + " " + $t("Members") + ": " + $t("{0}").format(get_assignees_names_list());
            } else {
                dialog_props.title = $t("Are you sure to delete this task?") + " " + $t("Members") + ": " + $t("{0}").format(get_assignees_names_list());
            }

            dialogModule.setConfirmOptions(dialog_props);
            dialogModule.openConfirmDialog();
        };

        const confirm_delete = function () {
            setTimeout(function () {
                    let task_type = task_data.value.recurrence_rule == null ? $t("task") : $t("recurring task");
                    let dialog_props = {
                        title: $t("Time has been tracked to this task.") + " " + $t("Are you sure to delete this task?"),
                        confirm_text: $t("Delete"),
                        cancel_text: $t("Cancel"),
                        action: delete_task_confirmed
                    };
                    dialogModule.setConfirmOptions(dialog_props);
                    dialogModule.openConfirmDialog();
                }, 0
            )
        }

        const delete_task_confirmed = function () {
            if (task_data.value.virtual_id && !(typeof task_data.value.virtual_id === 'string' && task_data.value.virtual_id.includes("tmp"))) {
                deleteTask(task_data.value)
                    .then(function (data) {
                        close();
                        ctx.emit('delete', data.id)
                        taskButtons.value = taskButtons.value.filter(button => button.task_id !== data.id)
                    })
                    .catch(function (ex) {
                        appModule.handleErrorResponse(null, ex);
                    });
            } else {
                close()
                ctx.emit('delete', task_data.value.id)
            }
        };
        const remove_me_confirmed = function () {
            let data = {
                id: task_data.value.id,
                virtual_id: task_data.value.virtual_id,
                assignees: task_data.value.assignees.filter(x => x !== current_account.value.id)
            };

            saveTaskField(data, "TaskView.remove_me_confirmed")
                .then(() => {
                    close();
                })
                .catch(ex => appModule.handleErrorResponse(form_data.value, ex));
        };
        const open_template = function () {
            let template_id = task_data.value.recurrence_id;
            let props = {};
            if (ctx.root._route.params.client_id !== undefined)
                props.client_id = parseInt(ctx.root._route.params.client_id);
            openTask(template_id, props);
        };
        const create_template = function () {
            let tmp_id = task_data.value.id;
            let props = {is_template: true};
            if (ctx.root._route.params.client_id !== undefined)
                props.client_id = parseInt(ctx.root._route.params.client_id);
            if (isGeneralTemplate.value) {
                return ctx.emit('close', {action: 'create_recurring', task_data: task_data.value})
            }
            openTask(tmp_id, props);
        };

        const handleSaveClick = function () {
            const client = clients.value.find(x => x.id === task_data.value.client_id)
            const validationResult = TaskValidationModule.validateSave(task_data.value, client, props.isJobTemplate || props.isWorkflowTemplate)
            if (!validationResult.success) {
                for (const key in validationResult.errors) {
                    const value = validationResult.errors[key]
                    const errorKey = `${key}_error`
                    form_data.value[errorKey] = value
                }
                return
            }

            return new Promise(function (resolve, reject) {
                saveLoading.value = true;
                saveTask().then(() => resolve()).catch()
            })
        };

        const getPostTaskParams = (fill_empty_required_fields) => {
            let params = {};
            if (props.isTemporaryClientTask) {
                params.validate_only = 1;
                if (props.isJobTemplate) params.is_job_template = 1;
                if (props.isWorkflowTemplate) params.is_workflow_template = 1;
            }
            if (props.isTaskButton) {
                task_data.value.type = 'button';
            }
            if (fill_empty_required_fields && !task_data.value.title) {
                task_data.value.title = `[${$t("Undefined")}]`;
            }
            if (fill_empty_required_fields && !task_data.value.client_id) {
                task_data.value.client_id = own_client_id.value;
            }

            return params;
        }

        const handlePostTaskResponse = (resp, resolve, reject, close_after_save) => {
            saveLoading.value = false;
            task_data.value.id = resp.id
            if (current_task.value) {
                current_task.value.just_added = true
            }
            handleTaskSentoToCP()

            if (form_data.value.time_entry != null) {
                form_data.value.time_entry.task_id = resp.id;
                timerModule
                    .saveTimeEntry(form_data.value.time_entry)
                    .then(function () {
                        resolve(resp.id);
                        if (close_after_save) close(!!resp.id)
                        else auto_save.value = true
                    })
                    .catch(function (ex) {
                        errorDialog.showError(ex);
                        reject();
                    });
            } else {
                resolve(resp.id);
                if (close_after_save) close(true)
                else auto_save.value = true
            }
        }

        const prepareSaveTask = () => {
            appModule.clearValidationErrors(form_data.value);
            if (!projectEnabled.value && task_data.value.project_id)
                task_data.value.project_id = null;
        }

        const clone_template = function () {
            let data = Vue.clone_object(task_data.value);
            delete data.task_button

            let params = {is_job_template: props.isJobTemplate};
            data.id = 0;
            data.virtual_id = null;
            data.title = "{0}: {1}".format($t("COPY"), data.title);

            if (data.automations) {
                for (let automationIndex in data.automations) {
                    data.automations[automationIndex].id = 0
                }
            }

            if (props.isJobTemplate) {
                let monthStart = new Date().calcMonthStart();
                data.date = formatSysDate(monthStart) + data.date.substr(10);
                data.recurrence_rule.date = formatSysDate(monthStart) + data.recurrence_rule.date.substr(10);
            }

            postTask(data, params)
                .then(() => {
                    ctx.emit("save");
                    close();
                })
                .catch(ex => appModule.handleErrorResponse(form_data.value, ex));
        };
        const close_click = function () {
            close();
        };
        const close = function (saved = false) {
            if (props.isTemporaryClientTask) {
                // if (saved) ctx.emit("save", null);
                // else ctx.emit("close");
                ctx.emit("close");
            } else {
                closeTask()
                if (props.isFullPage) {
                    if (router.currentRoute.name === "client_task") {
                        router.push({name: "client_profile_tasks", params: {id: router.currentRoute.params.client_id}});
                    } else if (router.currentRoute.name === "task") {
                        router.push({name: "dashboard"});
                    } else {
                        router.push({name: router.currentRoute.name});
                    }
                }
            }
        };

        const isWsUpdate = computed(function () {
            return (task_data.value.id !== 0 || props.taskId) && !props.isTemporaryClientTask;
        });
        const add_attachment_to_comment = function (resp, file) {
            if (footer_action.value !== TASK_FOOTER_ACTIONS.ADD_COMMENT && footer_action.value !== TASK_FOOTER_ACTIONS.ADD_MESSAGE) return;
            if (!file.for_comment) return;
            form_data.value.comment_attachments = [resp];
        };
        const fileUploadSaveTemporary = computed(() => {
            return !auto_save.value
        })
        const fileUpload = FileUpload("task", task_data, form_data, isWsUpdate, add_attachment_to_comment, null, true, fileUploadSaveTemporary);

        const comment_upload_change = function (e) {
            fileUpload.add_files_to_upload(e.target.files, true);
        };

        const saveTask = function (fill_empty_required_fields = false, close_after_save = true) {
            return new Promise(function (resolve, reject) {
                if (auto_save.value) {
                    resolve(task_data.value.id ? task_data.value.id : task_data.value.virtual_id);
                    return;
                }

                prepareSaveTask();

                if (!props.isTaskButton) {
                    delete task_data.value.task_button
                }

                const params = getPostTaskParams(fill_empty_required_fields);

                const postTaskData = {...task_data.value}
                postTaskData.files = form_data.value.files.map(x => ({...x}));

                postTask(postTaskData, params)
                    .then(resp => {
                        task_data.value.files = form_data.value.files.map(x => ({...x}));
                        ctx.emit("save");
                        handlePostTaskResponse(resp, resolve, reject, close_after_save);

                        // UKU-2600 :: todo metrics - read window
                        uku_send_event({event: UKU_ACTIVITIES.ADDED_TASK, info: "TaskView.saveTask"})
                    })
                    .catch(ex => {
                        saveLoading.value = false;
                        appModule.handleErrorResponse(form_data.value, ex);
                        handleCircularDependencyError(ex)
                        reject();
                    })
            });
        };

        const shouldCloseDialogOnTimerAction = function () {
            return current_account.value.data.task_remains_open_on_timer_start !== 1
        }

        const toggleStarted = function () {
            startLoading.value = true;

            const wasTaskRunningWhenYouClickedTheButton = isTaskRunning.value

            saveTask(true, shouldCloseDialogOnTimerAction())
                .then(saved_id => {
                    if (!wasTaskRunningWhenYouClickedTheButton) {
                        form_data.value.time_entry = null
                        execTimerAction("start", saved_id, shouldCloseDialogOnTimerAction());
                    } else {
                        form_data.value.time_entry = null
                        execTimerAction("pause", task_data.value.id, false);
                    }
                })
                .catch(() => {
                    startLoading.value = false;
                })
        };

        const populateFieldErrors = () => {
            let fields = task_data.value.fields ? Object.assign({}, task_data.value.fields) : {}

            for (const field of form_data_fields.value) {
                if (!fields[field.name + '_error']) {
                    fields[field.name + '_error'] = null
                }
            }

            task_data.value.fields = fields
        }

        const toggleCompleted = async () => {
            completeLoading.value = true;

            try {
                const saved_id = await saveTask(true, false)
                let action = task_data.value.status === "finished" ? "incomplete" : "complete";
                if (action === "complete") {
                    const companyAccount = getAccount(task_data.value.account_id)
                    const client = clients.value.find(x => x.id === task_data.value.client_id)

                    const validationResult = TaskValidationModule.validateToggleCompleted(companyAccount.value, client, task_data.value, form_data.value)
                    if (!validationResult.success && !isTaskRunning.value) {
                        errorDialog.showError({
                            message: validationResult.message,
                            details: validationResult.details
                        });
                        completeLoading.value = false;
                        return
                    }

                    await TimeEntryModule.completeTask(saved_id, false)
                } else {
                    await execTimerAction(action, saved_id, true)
                }

                close()
            } catch (ex) {
                populateFieldErrors()
                completeLoading.value = false;

                appModule.handleErrorResponse(form_data.value, ex);
            }
        }

        const execTimerAction = function (action, task_id, close_after_save = false, billable = true) {
            return new Promise(function (resolve, reject) {
                timerModule
                    .executeAction(action, task_id, true, null, null, billable)
                    .then(function () {
                        startLoading.value = false;
                        completeLoading.value = false;
                        if (close_after_save) close(true)
                        resolve()
                    })
                    .catch(function (ex) {
                        startLoading.value = false;
                        completeLoading.value = false;
                        appModule.handleErrorResponse({}, ex);
                        reject()
                    });
            })
        };
        const setTimeEntry = function (timeEntry) {
            form_data.value.time_entry = timeEntry;
            close_time_entries();
        };

        const currentTopic = computed(function () {
            if (!task_data.value.topic_id || !task_data.value.account_id) return null;

            if (appModule.topics.value[task_data.value.account_id] !== undefined) {
                let t = appModule.topics.value[task_data.value.account_id].find(x => x.id === task_data.value.topic_id);
                if (t != null) return t;
            }

            return appModule.base_topics.value.find(x => x.id === task_data.value.topic_id);
        });

        const autocomplete_select = function (item) {
            task_data.value.assignees = [].concat(current_account.value.id);
            task_data.value.title = item.name;
            if (item.client_id) task_data.value.client_id = item.client_id
            if (item.topic_id) task_data.value.topic_id = item.topic_id;
            if (item.estimation) task_data.value.estimation = item.estimation;
            if (item.description) task_data.value.description = item.description;
            if (item.checklist) task_data.value.checklist = {...item.checklist, checked_count: 0};
            if (item.recurrence_rule) task_data.value.recurrence_rule = item.recurrence_rule;
            if (item.is_important) task_data.value.is_important = item.is_important ? 1 : 0
            if (item.is_extra) task_data.value.is_extra = item.is_extra ? 1 : 0
            if (item.bill_by) task_data.value.bill_by = item.bill_by
            if (item.bill_at) task_data.value.bill_at = item.bill_at

            if (item.type === "task") {
                task_data.value.account_id = item.account_id;
                if (!task_data.value.client_id) {
                    focus_field("client_id");
                }
            }

            if (item.type === "client") {
                task_data.value.title = "";
                task_data.value.account_id = clients.value.filter(x => x.id === item.client_id)[0].account_id;
            }

            if (item.fields) {
                task_data.value.fields = item.fields;
                load_custom_fields();
            }
        };

        const convertChecklistItemToNewTask = idx => {
            const {client_id, checklist, topic_id, project_id} = task_data.value;
            const newTaskTitle = checklist.items[idx].description;

            closeTask();

            setTimeout(() => {
                openTask(0, {client_id, title: newTaskTitle, topic_id, project_id});
            }, 250);
        };

        const updateTaskTitle = input => {
            if (input !== null && typeof input === "object") {
                task_data.value.title = input.name;
            } else {
                task_data.value.title = input;
            }
        };

        watch(fields, function () {
            if (task_data.value != null && task_data.value.id !== 0) load_custom_fields();
        });
        watch(files, function () {
            if (task_data.value != null && !props.isTemporaryClientTask) load_files();
        });
        watch(estimation, function (val) {
            if (task_data.value != null) form_data.value.estimation_f = formatTimeDuration(val);
        });
        watch(
            () => [props.taskId, props.isTemplate],
            (newValue, prevValue) => {
                if (newValue && prevValue && newValue[0] === 0 && prevValue[0] > 0) {
                    return
                }

                load_data();
            }
        );

        function setAutoFocus(target) {
            if (!isAutoFocusSet.value) {
                autoFocusField.value = target;
                isAutoFocusSet.value = true;
            }
        }

        function focusClientOnClientTaskButton() {
            if (!task_dialog.value.isTaskButtonTask) {
                return;
            }

            const client = clients.value.find(x => x.id === client_id.value);
            if (!client) {
                return;
            }

            if (client && client.is_account) {
                setAutoFocus('clients')
            } else {
                setAutoFocus('title')
            }
        }

        const loadDigitizationEmail = async () => {
            digitizationEmail.value = null
            if (!task_data.value || !task_data.value.client_id) {
                return
            }

            const resp = await ApiDigitization.getDigitizationEmail(task_data.value.client_id)
            digitizationEmail.value = resp.email
        }

        watch(client_id, () => {
            load_client_portal_users();
            focusClientOnClientTaskButton();
            loadDigitizationEmail()
        });

        function postTaskButton() {
            let account_id = task_data.value.account_id
            if (task_data.value.id === 0) {
                saveTask().then(() => {
                    fetchTaskButtons(account_id);
                    close(true);
                })
            } else {
                saveTaskField({id: task_data.value.id, task_button: task_data.value.task_button}, "MagicButtonSettings.vue")
                    .then(response => {
                        task_data.value.task_button = response.data.task_button
                        fetchTaskButtons(task_data.value.account_id);
                        close(true);
                    })
                    .catch(function (ex) {
                        appModule.handleErrorResponse(form_data.value, ex);
                    })
            }
        }

        const download = async (file) => {
            // it's actually downloading but whatevs
            file.uploading = true
            try {
                await downloadFile('task_attachment', file)
            } catch (e) {
                errorDialog.showError(e)
            } finally {
                file.uploading = false
            }
        }

        const showFooterEmailing = () => {
            openFooterAction(TASK_FOOTER_ACTIONS.ADD_EMAIL)
            updateEmailContacts()
        }

        const updateEmailContacts = async (clientId = task_data.value.client_id, companyId = task_data.value.account_id, projectId = task_data.value.project_id) => {
            if (footer_action.value !== TASK_FOOTER_ACTIONS.ADD_EMAIL) {
                return
            }

            try {
                const data = await ApiEmailAutomationContacts.getTaskContacts(companyId, clientId, projectId, props.isWorkflowTemplate)
                fetchEmailAutomationTemplates(task_data.value.account_id)
                emailContacts.value = data.tabs
            } catch (ex) {
                errorDialog.showError(ex);
            }
        }

        const editAutomation = (index) => {
            editingAutomationIndex.value = index
            openFooterAction(TASK_FOOTER_ACTIONS.ADD_EMAIL)
            updateEmailContacts()
        }

        const updateAutomations = (e) => {
            editingAutomationIndex.value = null
            set_and_save_field('automations', e)
        }

        const openFooterAction = (action) => {
            footer_action.value = action
            if (action !== TASK_FOOTER_ACTIONS.MANAGE_TIME_ENTRIES) {
                ctx.emit('scrollDown', {task_content_height: 99999})
            }
        }

        const filterDependantTasks = (keyword) => {
            if (props.isTemporaryClientTask) {
                return
            }

            clearTimeout(filterDependantTasksTimeout)

            filterDependantTasksTimeout = setTimeout(() => {
                updateRelatedTasks(keyword)
            }, 300)
        }

        const startChecklistTimer = async (description) => {
            const client = clients.value.find(x => x.id === task_data.value.client_id)
            const validationResult = TaskValidationModule.validateSave(task_data.value, client, props.isJobTemplate || props.isWorkflowTemplate)
            if (!validationResult.success) {
                for (const key in validationResult.errors) {
                    const value = validationResult.errors[key]
                    const errorKey = `${key}_error`
                    form_data.value[errorKey] = value
                }
                return
            }

            if (timerModule.status.value === 'running') {
                await timerModule.executeAction('pause', timerModule.task_id.value)
            }

            try {
                const saved_id = await saveTask()
                await timerModule.executeAction('start', saved_id, false, null, description.substring(0, 255))
                close(true);
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        if (props.timeEntry) {
            form_data.value.time_entry = props.timeEntry
        }

        const visibleAutomations = computed(() => {
            if (!task_data.value) {
                return []
            }

            if (!task_data.value.automations) {
                return []
            }

            return task_data.value.automations.filter(x => x.status === 'new')
        })

        const filteredFiles = computed(() => {
            if (!form_data.value.files) {
                return []
            }

            let files = form_data.value.files.filter(x => !x.is_deleted)
            if (task_data.value.logs) {
                for (const taskLog of task_data.value.logs) {
                    if (taskLog.files) {
                        files = files.concat(taskLog.files)
                    }
                }
            }

            return files
        })

        const onDeleteFile = (file) => {
            if (auto_save.value) {
                fileUpload.delete_file(file)
                if (task_data.value.logs) {
                    for (const taskLog of task_data.value.logs) {
                        if (taskLog.files) {
                            taskLog.files = taskLog.files.filter(x => x.id !== file.id)
                        }
                    }
                }

            } else {
                const currentFiles = form_data.value.files.slice()
                currentFiles.find(x => (file.id && x.id === file.id) || (file.temp_id && x.temp_id === file.temp_id)).is_deleted = 1
                form_data.value.files = currentFiles

                if (task_data.value.logs) {
                    for (const taskLog of task_data.value.logs) {
                        if (taskLog.files) {
                            for (const file of taskLog.files) {
                                if (file.id === file.id) {
                                    file.is_deleted = 1
                                }
                            }
                        }
                    }
                }
            }
        }


        const onDownloadAllFiles = async () => {
            if (filteredFiles.value.length === 1) {
                try {
                    await download(filteredFiles.value[0])
                } catch (e) {
                    errorDialog.showError(e)
                }
            } else {
                const files = filteredFiles.value.map(x => ({
                    id: x.id,
                    temp_name: x.temp_name,
                    file_name: x.file_name
                }))
                let name = $t('Documents')
                if (task_data.value.title) {
                    name += ' - ' + task_data.value.title
                }

                try {
                    await downloadFiles(`/tasks/${props.taskId}/attachments/download`, name, files)
                } catch (e) {
                    errorDialog.showError(e)
                }
            }
        }

        const cpDueDate = computed(() => {
            if (!task_data.value.due_date) {
                return null
            }

            const dueDate = parseSysDateTime(task_data.value.due_date)
            dueDate.setDate(dueDate.getDate() - task_data.value.cp_due_date_offset)

            const startDate = parseSysDateTime(task_data.value.date)

            if (dueDate < startDate) {
                return formatSysDateTime(startDate)
            }

            return formatSysDateTime(dueDate)
        })

        const cpDueDateOffsetOptions = computed(() => {
            return [
                {
                    text: $t('On task due date'),
                    value: 0
                },
                {
                    text: $t('{0} day before').format(1),
                    value: 1
                },
                {
                    text: $t('{0} days before').format(2),
                    value: 2
                },
                {
                    text: $t('{0} days before').format(3),
                    value: 3
                },
                {
                    text: $t('{0} days before').format(4),
                    value: 4
                },
                {
                    text: $t('{0} days before').format(5),
                    value: 5
                },
                {
                    text: $t('{0} days before').format(6),
                    value: 6
                },
                {
                    text: $t('{0} days before').format(7),
                    value: 7
                },
            ]
        })

        const cpDueDateOffsetOptionsFiltered = computed(() => {
            let options = cpDueDateOffsetOptions.value

            options = options.map(x => {
                x.highlight = task_data.value.cp_due_date_offset === x.value

                return x
            })

            if (props.isWorkflowTemplate) {
                const dueDateIn = task_data.value.fields?.workflow_date_rule?.due_count_days
                if (!dueDateIn) {
                    return []
                }

                return options.filter(option => option.value <= dueDateIn)
            } else if (task_data.value.recurrence_rule) {
                // TODO: there are a bajillion rules to handle here
                // is this worth it to do right now?
                return options
            } else {
                const startDate = parseSysDateTime(task_data.value.date)

                return options.filter(option => {
                    const dueDate = parseSysDateTime(task_data.value.due_date)
                    dueDate.setDate(dueDate.getDate() - option.value)

                    return dueDate >= startDate
                })
            }
        })

        const currentlySelectedDueDateOffsetOptionText = computed(() => {
            if (props.isWorkflowTemplate) {
                return $t('Due date')
            }

            const item = cpDueDateOffsetOptions.value.find(x => x.value === task_data.value.cp_due_date_offset)

            return item ? item.text : null
        })

        const onSetBillBy = (value) => {
            task_data.value.bill_by = value;
            set_and_save_field('bill_by', value)

            if (value !== 'custom_date') {
                task_data.value.bill_at = null
            }
        }

        const onSetBillAt = (value) => {
            task_data.value.bill_at = value;
            set_and_save_field('bill_at', value)
        }

        const cpDueDateText = computed(() => {
            if (props.isWorkflowTemplate || props.isJobTemplate || task_data.value.recurrence_rule) {
                const option = cpDueDateOffsetOptions.value.find(x => x.value === task_data.value.cp_due_date_offset)

                return option ? option.text : ''
            }

            return `${$t('Due date')}: ${formatDateShort(cpDueDate.value)}`
        })

        return {
            ...fileUpload,
            auto_save,
            new_task,
            task_data,
            form_data,
            title_edit,
            content_height,
            titleField,
            clientField,
            assigneesField,
            cpAssigneesField,
            recurrenceRuleField,
            taskNotes,
            estimationField,
            topicField,
            saveButton1,
            saveButton2,
            postTaskButton,
            clients,
            users,
            classifiers_loaded,
            topics,
            currentTopic,
            custom_fields,
            show_topic,
            show_bill_by,
            header_class,
            client_enabled,
            menu_items,
            current_account,
            comment_enabled,
            footer_action,
            recurrence_rule_error,
            workflow_date_rule_error,
            show_footer,
            show_timer,
            isTaskRunning,
            timer_time,
            form_data_fields,
            running_time,
            save_button_text,
            formContentRef,
            estimations_menu,
            saveLoading,
            startLoading,
            completeLoading,
            clientPortalEnabled,
            clientPortalVisible,
            projectEnabled,
            cp_users,
            clientName,
            keep_only_me,
            project_enabled,
            isGeneralTemplate,
            hasWorkflowDateRule,
            curAvailableRelatedTasks,
            taskErrors,
            focus_field,
            focus_next,
            add_comment,
            add_message_or_comment,
            close_comment,
            manage_time_entries,
            close_time_entries,
            save_custom_field,
            client_changed,
            time_field_changed,
            update_checklist_field,
            toggle_field,
            toggle_custom_field,
            action_click,
            comment_upload_change,
            cancel_field,
            handleSaveClick,
            close_click,
            toggleStarted,
            toggleCompleted,
            setTimeEntry,
            open_custom_field_dialog,
            autocomplete_select,
            estimation_select,
            convertChecklistItemToNewTask,
            save_recurrence_field,
            updateTaskTitle,
            userfile735,
            task_dialog,
            autoFocusField,
            set_and_save_field,
            emailingEnabled,
            download,
            close_email,
            emailContacts,
            showFooterEmailing,
            editAutomation,
            editingAutomationIndex,
            updateAutomations,
            TASK_FOOTER_ACTIONS,
            openFooterAction,
            taskViewCard,
            isEmailingOnlyAutomations,
            emailingPlaceholderTypes,
            save_button_tooltip_text,
            dependsOnVisible,
            filterDependantTasks,
            saveProjectId,
            startChecklistTimer,
            projectVisible,
            visibleAutomations,
            onDeleteFile,
            filteredFiles,
            fileUploadSaveTemporary,
            resetTaskIsSeenForCPAssignees,
            onDownloadAllFiles,
            digitizationEmail,
            isDigitizationModalOpen,
            cpDueDateOffsetOptions,
            cpDueDate,
            formatDateShort,
            currentlySelectedDueDateOffsetOptionText,
            cpDueDateOffsetOptionsFiltered,
            onSetBillBy,
            onSetBillAt,
            cpDueDateText,
            tasks_list
        };
    }
};
</script>

<style>
.footer-actions .v-btn.v-btn--disabled .v-image {
    opacity: 0.6;
}


</style>

<style scoped lang="scss">
.cp-assign-menu {
    ::v-deep .add-user.n1:not(.actual-add-user) {
        background-color: var(--v-n2-base) !important;
    }

    ::v-deep .v-input .v-label {
        font-size: 11px !important;
        font-weight: 600 !important;
        line-height: normal !important;
    }
}
</style>